var Fe = Object.defineProperty;
var He = (n, e, t) => e in n ? Fe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var m = (n, e, t) => He(n, typeof e != "symbol" ? e + "" : e, t);
import { Fragment as A, Slice as N, DOMSerializer as ke, DOMParser as $e, Node as Ve } from "prosemirror-model";
import { ReplaceAroundStep as V, ReplaceStep as Ue } from "prosemirror-transform";
import { q as Y, r as F, s as y, n as U, i as q, g as S, b as Z, u as H, a as b, t as ze, U as O, v as _, d as Ge, w as Re, x as je, y as ge, z as We, A as z } from "./nodeToBlock-DJYxfW65.js";
import { B as os, G as ns, C as ss, D as rs, N as as, E as is, O as cs, F as ls, H as ds, I as us, L as ps, J as fs, M as hs, K as ms } from "./nodeToBlock-DJYxfW65.js";
import { ab as Ke, ae as G, as as Je, at as Ye, ac as qe, au as be, av as $, aw as Ze, ax as Qe, ay as Xe, az as Q, ar as E, aA as et, aB as tt, aC as X, af as ye, aD as ot } from "./defaultBlocks-CUZfrbY-.js";
import { aG as gs, aF as bs, E as ys, a as Ss, F as Bs, r as Cs, N as Es, aa as xs, aj as Ms, aS as Ts, aH as ws, b as Ps, d as vs, e as Is, a5 as As, a2 as _s, aY as Ds, aE as Ls, c as Ns, f as Os, am as Fs, an as Hs, aL as $s, x as Vs, y as Us, A as zs, z as Gs, g as Rs, h as js, T as Ws, j as Ks, k as Js, l as Ys, n as qs, o as Zs, q as Qs, s as Xs, w as er, aM as tr, aT as or, B as nr, C as sr, H as rr, I as ar, ao as ir, J as cr, K as lr, aQ as dr, aU as ur, M as pr, D as fr, G as hr, S as mr, O as kr, Q as gr, W as br, U as yr, _ as Sr, Z as Br, a8 as Cr, Y as Er, X as xr, R as Mr, a7 as Tr, $ as wr, a1 as Pr, a0 as vr, m as Ir, aZ as Ar, aW as _r, aJ as Dr, al as Lr, i as Nr, aI as Or, aP as Fr, ak as Hr, ad as $r, t as Vr, u as Ur, v as zr, aV as Gr, a3 as Rr, aq as jr, aX as Wr, a4 as Kr, V as Jr, a6 as Yr, p as qr, a9 as Zr, aO as Qr, aN as Xr, aR as ea, L as ta, a_ as oa, P as na, aK as sa } from "./defaultBlocks-CUZfrbY-.js";
import { c as R, j as nt, k as Se, l as st, m as rt, n as at, B as it, D as ct, L as lt, N as dt, P as ut, g as pt, i as ft, F as ht, Y as mt, a as kt, b as gt, S as bt, H as yt, h as St, e as Bt, V as Ct, d as Et } from "./TrailingNode-unN5_Fik.js";
import { s as xt, B as Mt } from "./BlockNoteSchema-BLLpev-1.js";
import { C as aa, b as ia, c as ca, a as la, g as da, u as ua, w as pa } from "./BlockNoteSchema-BLLpev-1.js";
import { Extension as x, Node as D, mergeAttributes as Tt, Mark as ee, extensions as I, isNodeSelection as wt, posToDOMRect as Pt, selectionToInsertionEnd as vt, getSchema as It, createDocument as At, Editor as _t } from "@tiptap/core";
import { E as Be } from "./EventEmitter-CjSwpTbz.js";
import { Fragment as te, Slice as re } from "@tiptap/pm/model";
import { e as Dt } from "./en-DEAT7myV.js";
import { inputRules as Lt, InputRule as Nt } from "@handlewithcare/prosemirror-inputrules";
import { keymap as Ot } from "@tiptap/pm/keymap";
import { o as Ft } from "./BlockNoteExtension-C2X7LW-V.js";
import { c as ha, a as ma } from "./BlockNoteExtension-C2X7LW-V.js";
import { Gapcursor as Ht } from "@tiptap/extension-gapcursor";
import { Link as $t } from "@tiptap/extension-link";
import { Text as Vt } from "@tiptap/extension-text";
import { TextSelection as M, NodeSelection as L, Plugin as oe } from "prosemirror-state";
import { CellSelection as ne, TableMap as ae } from "prosemirror-tables";
import { S as Ut } from "./ShowSelection-Dz-NEase.js";
import zt from "remark-gfm";
import Gt from "remark-parse";
import Rt, { defaultHandlers as ie } from "remark-rehype";
import jt from "rehype-stringify";
import { unified as Wt } from "unified";
import { TextSelection as Kt } from "@tiptap/pm/state";
const Jt = x.create({
  name: "blockBackgroundColor",
  addGlobalAttributes() {
    return [
      {
        types: ["tableCell", "tableHeader"],
        attributes: {
          backgroundColor: Ke()
        }
      }
    ];
  }
}), Yt = D.create({
  name: "hardBreak",
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  priority: 10,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", Tt(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  }
}), j = (n, e) => {
  const t = n.resolve(e), o = t.index();
  if (o === 0)
    return;
  const s = t.posAtIndex(o - 1);
  return Y(
    n.resolve(s)
  );
}, Ce = (n, e) => {
  for (; e.childContainer; ) {
    const t = e.childContainer.node, o = n.resolve(e.childContainer.beforePos + 1).posAtIndex(t.childCount - 1);
    e = Y(n.resolve(o));
  }
  return e;
}, qt = (n, e) => n.isBlockContainer && n.blockContent.node.type.spec.content === "inline*" && n.blockContent.node.childCount > 0 && e.isBlockContainer && e.blockContent.node.type.spec.content === "inline*", Zt = (n, e, t, o) => {
  if (!o.isBlockContainer)
    throw new Error(
      `Attempted to merge block at position ${o.bnBlock.beforePos} into previous block at position ${t.bnBlock.beforePos}, but next block is not a block container`
    );
  if (o.childContainer) {
    const s = n.doc.resolve(
      o.childContainer.beforePos + 1
    ), a = n.doc.resolve(
      o.childContainer.afterPos - 1
    ), r = s.blockRange(a);
    if (e) {
      const c = n.doc.resolve(o.bnBlock.beforePos);
      n.tr.lift(r, c.depth);
    }
  }
  if (e) {
    if (!t.isBlockContainer)
      throw new Error(
        `Attempted to merge block at position ${o.bnBlock.beforePos} into previous block at position ${t.bnBlock.beforePos}, but previous block is not a block container`
      );
    e(
      n.tr.delete(
        t.blockContent.afterPos - 1,
        o.blockContent.beforePos + 1
      )
    );
  }
  return !0;
}, ce = (n) => ({
  state: e,
  dispatch: t
}) => {
  const o = e.doc.resolve(n), s = Y(o), a = j(
    e.doc,
    s.bnBlock.beforePos
  );
  if (!a)
    return !1;
  const r = Ce(
    e.doc,
    a
  );
  return qt(r, s) ? Zt(e, t, r, s) : !1;
};
function Qt(n, e, t) {
  const { $from: o, $to: s } = n.selection, a = o.blockRange(
    s,
    (f) => f.childCount > 0 && (f.type.name === "blockGroup" || f.type.name === "column")
    // change necessary to not look at first item child type
  );
  if (!a)
    return !1;
  const r = a.startIndex;
  if (r === 0)
    return !1;
  const i = a.parent.child(r - 1);
  if (i.type !== e)
    return !1;
  const l = i.lastChild && i.lastChild.type === t, d = A.from(l ? e.create() : null), u = new N(
    A.from(
      e.create(null, A.from(t.create(null, d)))
      // change necessary to create "groupType" instead of parent.type
    ),
    l ? 3 : 1,
    0
  ), p = a.start, h = a.end;
  return n.step(
    new V(
      p - (l ? 3 : 1),
      h,
      p,
      h,
      u,
      1,
      !0
    )
  ).scrollIntoView(), !0;
}
function Ee(n) {
  return n.transact((e) => Qt(
    e,
    n.pmSchema.nodes.blockContainer,
    n.pmSchema.nodes.blockGroup
  ));
}
function Xt(n) {
  n._tiptapEditor.commands.liftListItem("blockContainer");
}
function eo(n) {
  return n.transact((e) => {
    const { bnBlock: t } = F(e);
    return e.doc.resolve(t.beforePos).nodeBefore !== null;
  });
}
function to(n) {
  return n.transact((e) => {
    const { bnBlock: t } = F(e);
    return e.doc.resolve(t.beforePos).depth > 1;
  });
}
function W(n) {
  if (!n || n.type.name !== "column")
    throw new Error("Invalid columnPos: does not point to column node.");
  const e = n.firstChild;
  if (!e)
    throw new Error("Invalid column: does not have child node.");
  const t = e.firstChild;
  if (!t)
    throw new Error("Invalid blockContainer: does not have child node.");
  return n.childCount === 1 && e.childCount === 1 && t.type.name === "paragraph" && t.content.content.length === 0;
}
function oo(n, e) {
  const t = n.doc.resolve(e), o = t.nodeAfter;
  if (!o || o.type.name !== "columnList")
    throw new Error(
      "Invalid columnListPos: does not point to columnList node."
    );
  for (let s = o.childCount - 1; s >= 0; s--) {
    const a = n.doc.resolve(t.pos + 1).posAtIndex(s), c = n.doc.resolve(a).nodeAfter;
    if (!c || c.type.name !== "column")
      throw new Error("Invalid columnPos: does not point to column node.");
    W(c) && n.delete(a, a + c.nodeSize);
  }
}
function K(n, e) {
  oo(n, e);
  const o = n.doc.resolve(e).nodeAfter;
  if (!o || o.type.name !== "columnList")
    throw new Error(
      "Invalid columnListPos: does not point to columnList node."
    );
  if (o.childCount > 2)
    return;
  if (o.childCount < 2)
    throw new Error("Invalid columnList: contains fewer than two children.");
  const s = e + 1, r = n.doc.resolve(s).nodeAfter, c = e + o.nodeSize - 1, l = n.doc.resolve(c).nodeBefore;
  if (!r || !l)
    throw new Error("Invalid columnList: does not contain children.");
  const d = W(r), u = W(l);
  if (d && u) {
    n.delete(e, e + o.nodeSize);
    return;
  }
  if (d) {
    n.step(
      new V(
        // Replaces `columnList`.
        e,
        e + o.nodeSize,
        // Replaces with content of last `column`.
        c - l.nodeSize + 1,
        c - 1,
        // Doesn't append anything.
        N.empty,
        0,
        !1
      )
    );
    return;
  }
  if (u) {
    n.step(
      new V(
        // Replaces `columnList`.
        e,
        e + o.nodeSize,
        // Replaces with content of first `column`.
        s + 1,
        s + r.nodeSize - 1,
        // Doesn't append anything.
        N.empty,
        0,
        !1
      )
    );
    return;
  }
}
const no = x.create({
  priority: 50,
  // TODO: The shortcuts need a refactor. Do we want to use a command priority
  //  design as there is now, or clump the logic into a single function?
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ chain: o, commands: s }) => [
      // Deletes the selection if it's not empty.
      () => s.deleteSelection(),
      // Undoes an input rule if one was triggered in the last editor state change.
      () => s.undoInputRule(),
      // Reverts block content type to a paragraph if the selection is at the start of the block.
      () => s.command(({ state: a }) => {
        const r = y(a);
        if (!r.isBlockContainer)
          return !1;
        const c = a.selection.from === r.blockContent.beforePos + 1, i = r.blockContent.node.type.name === "paragraph";
        return c && !i ? s.command(
          Ye(r.bnBlock.beforePos, {
            type: "paragraph",
            props: {}
          })
        ) : !1;
      }),
      // Removes a level of nesting if the block is indented if the selection is at the start of the block.
      () => s.command(({ state: a }) => {
        const r = y(a);
        if (!r.isBlockContainer)
          return !1;
        const { blockContent: c } = r;
        return a.selection.from === c.beforePos + 1 ? s.liftListItem("blockContainer") : !1;
      }),
      // Merges block with the previous one if it isn't indented, and the selection is at the start of the
      // block. The target block for merging must contain inline content.
      () => s.command(({ state: a }) => {
        const r = y(a);
        if (!r.isBlockContainer)
          return !1;
        const { bnBlock: c, blockContent: i } = r, l = a.selection.from === i.beforePos + 1, d = a.selection.empty, u = c.beforePos;
        return l && d ? o().command(ce(u)).scrollIntoView().run() : !1;
      }),
      () => s.command(({ state: a, tr: r, dispatch: c }) => {
        const i = y(a);
        if (!i.isBlockContainer || !(r.selection.from === i.blockContent.beforePos + 1))
          return !1;
        const d = r.doc.resolve(i.bnBlock.beforePos);
        if (d.nodeBefore || d.node().type.name !== "column")
          return !1;
        const h = r.doc.resolve(i.bnBlock.beforePos), f = r.doc.resolve(h.before()), k = f.before();
        if (c) {
          const g = r.doc.slice(
            i.bnBlock.beforePos,
            i.bnBlock.afterPos
          ).content;
          r.delete(
            i.bnBlock.beforePos,
            i.bnBlock.afterPos
          ), f.index() === 0 ? (K(r, k), r.insert(k, g), r.setSelection(
            M.near(r.doc.resolve(k))
          )) : (r.insert(f.pos - 1, g), r.setSelection(
            M.near(r.doc.resolve(f.pos - 1))
          ), K(r, k));
        }
        return !0;
      }),
      // Deletes the current block if it's an empty block with inline content,
      // and moves the selection to the previous block.
      () => s.command(({ state: a }) => {
        const r = y(a);
        if (!r.isBlockContainer)
          return !1;
        if (r.blockContent.node.childCount === 0 && r.blockContent.node.type.spec.content === "inline*") {
          const i = j(
            a.doc,
            r.bnBlock.beforePos
          );
          if (!i || !i.isBlockContainer)
            return !1;
          let l = o();
          if (i.blockContent.node.type.spec.content === "tableRow+") {
            const f = r.bnBlock.beforePos - 1 - 1 - 1 - 1 - 1;
            l = l.setTextSelection(
              f
            );
          } else if (i.blockContent.node.type.spec.content === "") {
            const d = i.blockContent.afterPos - i.blockContent.node.nodeSize;
            l = l.setNodeSelection(
              d
            );
          } else {
            const d = i.blockContent.afterPos - i.blockContent.node.nodeSize;
            l = l.setTextSelection(d);
          }
          return l.deleteRange({
            from: r.bnBlock.beforePos,
            to: r.bnBlock.afterPos
          }).scrollIntoView().run();
        }
        return !1;
      }),
      // Deletes previous block if it contains no content and isn't a table,
      // when the selection is empty and at the start of the block. Moves the
      // current block into the deleted block's place.
      () => s.command(({ state: a }) => {
        const r = y(a);
        if (!r.isBlockContainer)
          throw new Error("todo");
        const c = a.selection.from === r.blockContent.beforePos + 1, i = a.selection.empty, l = j(
          a.doc,
          r.bnBlock.beforePos
        );
        if (l && c && i) {
          const d = Ce(
            a.doc,
            l
          );
          if (!d.isBlockContainer)
            throw new Error("todo");
          if (d.blockContent.node.type.spec.content === "" || d.blockContent.node.type.spec.content === "inline*" && d.blockContent.node.childCount === 0)
            return o().cut(
              {
                from: r.bnBlock.beforePos,
                to: r.bnBlock.afterPos
              },
              d.bnBlock.afterPos
            ).deleteRange({
              from: d.bnBlock.beforePos,
              to: d.bnBlock.afterPos
            }).run();
        }
        return !1;
      })
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      // Deletes the selection if it's not empty.
      () => o.deleteSelection(),
      // Merges block with the next one (at the same nesting level or lower),
      // if one exists, the block has no children, and the selection is at the
      // end of the block.
      () => o.command(({ state: s }) => {
        const a = y(s);
        if (!a.isBlockContainer)
          return !1;
        const {
          bnBlock: r,
          blockContent: c,
          childContainer: i
        } = a, { depth: l } = s.doc.resolve(r.beforePos), d = r.afterPos === s.doc.nodeSize - 3, u = s.selection.from === c.afterPos - 1, p = s.selection.empty;
        if (!d && u && p && !(i !== void 0)) {
          let f = l, k = r.afterPos + 1, g = s.doc.resolve(k).depth;
          for (; g < f; )
            f = g, k += 2, g = s.doc.resolve(k).depth;
          return o.command(ce(k - 1));
        }
        return !1;
      })
    ]), t = (o = !1) => this.editor.commands.first(({ commands: s, tr: a }) => [
      // Removes a level of nesting if the block is empty & indented, while the selection is also empty & at the start
      // of the block.
      () => s.command(({ state: r }) => {
        const c = y(r);
        if (!c.isBlockContainer)
          return !1;
        const { bnBlock: i, blockContent: l } = c, { depth: d } = r.doc.resolve(i.beforePos), u = r.selection.$anchor.parentOffset === 0, p = r.selection.anchor === r.selection.head, h = l.node.childCount === 0, f = d > 1;
        return u && p && h && f ? s.liftListItem("blockContainer") : !1;
      }),
      // Creates a hard break if block is configured to do so.
      () => s.command(({ state: r }) => {
        var l;
        const c = y(r), i = ((l = this.options.editor.schema.blockSchema[c.blockNoteType].meta) == null ? void 0 : l.hardBreakShortcut) ?? "shift+enter";
        if (i === "none")
          return !1;
        if (
          // If shortcut is not configured, or is configured as "shift+enter",
          // create a hard break for shift+enter, but not for enter.
          i === "shift+enter" && o || // If shortcut is configured as "enter", create a hard break for
          // both enter and shift+enter.
          i === "enter"
        ) {
          const d = a.storedMarks || a.selection.$head.marks().filter(
            (u) => this.editor.extensionManager.splittableMarks.includes(
              u.type.name
            )
          );
          return a.insert(
            a.selection.head,
            a.doc.type.schema.nodes.hardBreak.create()
          ).ensureMarks(d), !0;
        }
        return !1;
      }),
      // Creates a new block and moves the selection to it if the current one is empty, while the selection is also
      // empty & at the start of the block.
      () => s.command(({ state: r, dispatch: c }) => {
        const i = y(r);
        if (!i.isBlockContainer)
          return !1;
        const { bnBlock: l, blockContent: d } = i, u = r.selection.$anchor.parentOffset === 0, p = r.selection.anchor === r.selection.head, h = d.node.childCount === 0;
        if (u && p && h) {
          const f = l.afterPos, k = f + 2;
          if (c) {
            const g = r.schema.nodes.blockContainer.createAndFill();
            r.tr.insert(f, g).scrollIntoView(), r.tr.setSelection(
              new M(r.doc.resolve(k))
            );
          }
          return !0;
        }
        return !1;
      }),
      // Splits the current block, moving content inside that's after the cursor to a new text block below. Also
      // deletes the selection beforehand, if it's not empty.
      () => s.command(({ state: r, chain: c }) => {
        const i = y(r);
        if (!i.isBlockContainer)
          return !1;
        const { blockContent: l } = i, d = r.selection.$anchor.parentOffset === 0;
        return l.node.childCount === 0 ? !1 : (c().deleteSelection().command(
          Je(
            r.selection.from,
            d,
            d
          )
        ).run(), !0);
      })
    ]);
    return {
      Backspace: n,
      Delete: e,
      Enter: () => t(),
      "Shift-Enter": () => t(!0),
      // Always returning true for tab key presses ensures they're not captured by the browser. Otherwise, they blur the
      // editor since the browser will try to use tab for keyboard navigation.
      Tab: () => {
        var o, s;
        return this.options.tabBehavior !== "prefer-indent" && ((o = this.options.editor.getExtension(R)) != null && o.store.state || ((s = this.options.editor.getExtension(G)) == null ? void 0 : s.store.state) !== void 0) ? !1 : Ee(this.options.editor);
      },
      "Shift-Tab": () => {
        var o, s;
        return this.options.tabBehavior !== "prefer-indent" && ((o = this.options.editor.getExtension(R)) != null && o.store.state || ((s = this.options.editor.getExtension(G)) == null ? void 0 : s.store.state) !== void 0) ? !1 : this.editor.commands.liftListItem("blockContainer");
      },
      "Shift-Mod-ArrowUp": () => (this.options.editor.moveBlocksUp(), !0),
      "Shift-Mod-ArrowDown": () => (this.options.editor.moveBlocksDown(), !0),
      "Mod-z": () => this.options.editor.undo(),
      "Mod-y": () => this.options.editor.redo(),
      "Shift-Mod-z": () => this.options.editor.redo()
    };
  }
}), so = ee.create({
  name: "insertion",
  inclusive: !1,
  excludes: "deletion modification insertion",
  addAttributes() {
    return {
      id: { default: null, validate: "number" }
      // note: validate is supported in prosemirror but not in tiptap, so this doesn't actually work (considered not critical)
    };
  },
  extendMarkSchema(n) {
    return n.name !== "insertion" ? {} : {
      blocknoteIgnore: !0,
      inclusive: !1,
      toDOM(e, t) {
        return [
          "ins",
          {
            "data-id": String(e.attrs.id),
            "data-inline": String(t),
            ...!t && { style: "display: contents" }
            // changed to "contents" to make this work for table rows
          },
          0
        ];
      },
      parseDOM: [
        {
          tag: "ins",
          getAttrs(e) {
            return e.dataset.id ? {
              id: parseInt(e.dataset.id, 10)
            } : !1;
          }
        }
      ]
    };
  }
}), ro = ee.create({
  name: "deletion",
  inclusive: !1,
  excludes: "insertion modification deletion",
  addAttributes() {
    return {
      id: { default: null, validate: "number" }
      // note: validate is supported in prosemirror but not in tiptap
    };
  },
  extendMarkSchema(n) {
    return n.name !== "deletion" ? {} : {
      blocknoteIgnore: !0,
      inclusive: !1,
      // attrs: {
      //   id: { validate: "number" },
      // },
      toDOM(e, t) {
        return [
          "del",
          {
            "data-id": String(e.attrs.id),
            "data-inline": String(t),
            ...!t && { style: "display: contents" }
            // changed to "contents" to make this work for table rows
          },
          0
        ];
      },
      parseDOM: [
        {
          tag: "del",
          getAttrs(e) {
            return e.dataset.id ? {
              id: parseInt(e.dataset.id, 10)
            } : !1;
          }
        }
      ]
    };
  }
}), ao = ee.create({
  name: "modification",
  inclusive: !1,
  excludes: "deletion insertion",
  addAttributes() {
    return {
      id: { default: null, validate: "number" },
      type: { validate: "string" },
      attrName: { default: null, validate: "string|null" },
      previousValue: { default: null },
      newValue: { default: null }
    };
  },
  extendMarkSchema(n) {
    return n.name !== "modification" ? {} : {
      blocknoteIgnore: !0,
      inclusive: !1,
      // attrs: {
      //   id: { validate: "number" },
      //   type: { validate: "string" },
      //   attrName: { default: null, validate: "string|null" },
      //   previousValue: { default: null },
      //   newValue: { default: null },
      // },
      toDOM(e, t) {
        return [
          t ? "span" : "div",
          {
            "data-type": "modification",
            "data-id": String(e.attrs.id),
            "data-mod-type": e.attrs.type,
            "data-mod-prev-val": JSON.stringify(e.attrs.previousValue),
            // TODO: Try to serialize marks with toJSON?
            "data-mod-new-val": JSON.stringify(e.attrs.newValue)
          },
          0
        ];
      },
      parseDOM: [
        {
          tag: "span[data-type='modification']",
          getAttrs(e) {
            return e.dataset.id ? {
              id: parseInt(e.dataset.id, 10),
              type: e.dataset.modType,
              previousValue: e.dataset.modPrevVal,
              newValue: e.dataset.modNewVal
            } : !1;
          }
        },
        {
          tag: "div[data-type='modification']",
          getAttrs(e) {
            return e.dataset.id ? {
              id: parseInt(e.dataset.id, 10),
              type: e.dataset.modType,
              previousValue: e.dataset.modPrevVal
            } : !1;
          }
        }
      ]
    };
  }
}), io = x.create({
  name: "textAlignment",
  addGlobalAttributes() {
    return [
      {
        // Generally text alignment is handled through props using the custom
        // blocks API. Tables are the only blocks that are created as TipTap
        // nodes and ported to blocks, so we need to add text alignment in a
        // separate extension.
        types: ["tableCell", "tableHeader"],
        attributes: {
          textAlignment: {
            default: "left",
            parseHTML: (n) => n.getAttribute("data-text-alignment"),
            renderHTML: (n) => n.textAlignment === "left" ? {} : {
              "data-text-alignment": n.textAlignment
            }
          }
        }
      }
    ];
  }
}), co = x.create({
  name: "blockTextColor",
  addGlobalAttributes() {
    return [
      {
        types: ["table", "tableCell", "tableHeader"],
        attributes: {
          textColor: qe()
        }
      }
    ];
  }
});
function lo(n, e) {
  const t = [
    {
      tag: `[data-inline-content-type="${n.type}"]`,
      contentElement: (o) => {
        const s = o;
        return s.matches("[data-editable]") ? s : s.querySelector("[data-editable]") || s;
      }
    }
  ];
  return e && t.push({
    tag: "*",
    getAttrs(o) {
      if (typeof o == "string")
        return !1;
      const s = e == null ? void 0 : e(o);
      return s === void 0 ? !1 : s;
    }
  }), t;
}
function qn(n, e) {
  var o;
  const t = D.create({
    name: n.type,
    inline: !0,
    group: "inline",
    draggable: (o = e.meta) == null ? void 0 : o.draggable,
    selectable: n.content === "styled",
    atom: n.content === "none",
    content: n.content === "styled" ? "inline*" : "",
    addAttributes() {
      return Qe(n.propSchema);
    },
    addKeyboardShortcuts() {
      return Ze(n);
    },
    parseHTML() {
      return lo(
        n,
        e.parse
      );
    },
    renderHTML({ node: s }) {
      const a = this.options.editor, r = e.render.call(
        { renderType: "dom", props: void 0 },
        U(
          s,
          a.schema.inlineContentSchema,
          a.schema.styleSchema
        ),
        // TODO: fix cast
        () => {
        },
        a
      );
      return $(
        r,
        n.type,
        s.attrs,
        n.propSchema
      );
    },
    addNodeView() {
      return (s) => {
        const { node: a, getPos: r } = s, c = this.options.editor, i = e.render.call(
          { renderType: "nodeView", props: s },
          U(
            a,
            c.schema.inlineContentSchema,
            c.schema.styleSchema
          ),
          // TODO: fix cast
          (l) => {
            const d = be(
              [l],
              c.schema.inlineContentSchema
            ), u = q(d, c.pmSchema), p = r();
            p && c.transact(
              (h) => h.replaceWith(p, p + a.nodeSize, u)
            );
          },
          c
        );
        return $(
          i,
          n.type,
          a.attrs,
          n.propSchema
        );
      };
    }
  });
  return Xe(
    t,
    n.propSchema,
    {
      ...e,
      toExternalHTML: e.toExternalHTML,
      render(s, a, r) {
        const c = e.render(
          s,
          a,
          r
        );
        return $(
          c,
          n.type,
          s.props,
          n.propSchema
        );
      }
    }
  );
}
function uo(n, e, t, o = "before") {
  const s = typeof t == "string" ? t : t.id, a = S(n), r = e.map(
    (d) => Z(
      Q(H(a), d),
      a
    )
  ), c = E(s, n.doc);
  if (!c)
    throw new Error(`Block with ID ${s} not found`);
  let i = c.posBeforeNode;
  return o === "after" && (i += c.node.nodeSize), n.step(
    new Ue(i, i, new N(A.from(r), 0, 0))
  ), r.map(
    (d) => b(d, a)
  );
}
function le(n, e, t) {
  const o = S(n), s = t.map(
    (u) => Z(
      Q(H(o), u),
      o
    )
  ), a = new Set(
    e.map(
      (u) => typeof u == "string" ? u : u.id
    )
  ), r = [], c = /* @__PURE__ */ new Set(), i = typeof e[0] == "string" ? e[0] : e[0].id;
  let l = 0;
  if (n.doc.descendants((u, p) => {
    if (a.size === 0)
      return !1;
    if (!u.type.isInGroup("bnBlock") || !a.has(u.attrs.id))
      return !0;
    if (r.push(b(u, o)), a.delete(u.attrs.id), t.length > 0 && u.attrs.id === i) {
      const g = n.doc.nodeSize;
      n.insert(p, s);
      const B = n.doc.nodeSize;
      l += g - B;
    }
    const h = n.doc.nodeSize, f = n.doc.resolve(p - l);
    f.node().type.name === "column" ? c.add(f.before(-1)) : f.node().type.name === "columnList" && c.add(f.before()), f.node().type.name === "blockGroup" && f.node(f.depth - 1).type.name !== "doc" && f.node().childCount === 1 ? n.delete(f.before(), f.after()) : n.delete(p - l, p - l + u.nodeSize);
    const k = n.doc.nodeSize;
    return l += h - k, !1;
  }), a.size > 0) {
    const u = [...a].join(`
`);
    throw Error(
      "Blocks with the following IDs could not be found in the editor: " + u
    );
  }
  return c.forEach((u) => K(n, u)), { insertedBlocks: s.map(
    (u) => b(u, o)
  ), removedBlocks: r };
}
function po(n, e, t, o, s) {
  let a;
  if (e)
    if (Array.isArray(e))
      a = q(e, n.pmSchema, o);
    else if (e.type === "tableContent")
      a = ze(e, n.pmSchema);
    else
      throw new O(e.type);
  else throw new Error("blockContent is required");
  const c = ((s == null ? void 0 : s.document) ?? document).createDocumentFragment();
  for (const i of a)
    if (i.type.name !== "text" && n.schema.inlineContentSchema[i.type.name]) {
      const l = n.schema.inlineContentSpecs[i.type.name].implementation;
      if (l) {
        const d = U(
          i,
          n.schema.inlineContentSchema,
          n.schema.styleSchema
        ), u = l.render.call(
          {
            renderType: "dom",
            props: void 0
          },
          d,
          () => {
          },
          n
        );
        if (u) {
          if (c.appendChild(u.dom), u.contentDOM) {
            const p = t.serializeFragment(
              i.content,
              s
            );
            u.contentDOM.dataset.editable = "", u.contentDOM.appendChild(p);
          }
          continue;
        }
      }
    } else if (i.type.name === "text") {
      let l = document.createTextNode(
        i.textContent
      );
      for (const d of i.marks.toReversed())
        if (d.type.name in n.schema.styleSpecs) {
          const u = n.schema.styleSpecs[d.type.name].implementation.render(d.attrs.stringValue, n);
          u.contentDOM.appendChild(l), l = u.dom;
        } else {
          const u = d.type.spec.toDOM(d, !0), p = ke.renderSpec(document, u);
          p.contentDOM.appendChild(l), l = p.dom;
        }
      c.appendChild(l);
    } else {
      const l = t.serializeFragment(
        A.from([i]),
        s
      );
      c.appendChild(l);
    }
  return c;
}
function fo(n, e, t, o) {
  var l, d, u, p, h;
  const s = n.pmSchema.nodes.blockContainer, r = n.blockImplementations[e.type].implementation.render.call(
    {
      renderType: "dom",
      props: void 0
    },
    e,
    n
  );
  if (r.contentDOM && e.content) {
    const f = po(
      n,
      e.content,
      t,
      e.type,
      o
    );
    r.contentDOM.appendChild(f);
  }
  if (n.pmSchema.nodes[e.type].isInGroup("bnBlock")) {
    if (e.children && e.children.length > 0) {
      const f = xe(
        n,
        e.children,
        t,
        o
      );
      (l = r.contentDOM) == null || l.append(f);
    }
    return r.dom;
  }
  const i = (u = (d = s.spec) == null ? void 0 : d.toDOM) == null ? void 0 : u.call(
    d,
    s.create({
      id: e.id,
      ...e.props
    })
  );
  return (p = i.contentDOM) == null || p.appendChild(r.dom), e.children && e.children.length > 0 && ((h = i.contentDOM) == null || h.appendChild(
    Me(n, e.children, t, o)
  )), i.dom;
}
function xe(n, e, t, o) {
  const a = ((o == null ? void 0 : o.document) ?? document).createDocumentFragment();
  for (const r of e) {
    const c = fo(n, r, t, o);
    a.appendChild(c);
  }
  return a;
}
const Me = (n, e, t, o) => {
  var c;
  const s = n.pmSchema.nodes.blockGroup, a = s.spec.toDOM(s.create({})), r = xe(n, e, t, o);
  return (c = a.contentDOM) == null || c.appendChild(r), a.dom;
}, ho = (n, e) => {
  const t = ke.fromSchema(n);
  return {
    serializeBlocks: (o, s) => Me(e, o, t, s).outerHTML
  };
};
function mo(n) {
  return n.transact((e) => {
    const t = _(e.doc, e.selection.anchor);
    if (e.selection instanceof ne)
      return {
        type: "cell",
        anchorBlockId: t.node.attrs.id,
        anchorCellOffset: e.selection.$anchorCell.pos - t.posBeforeNode,
        headCellOffset: e.selection.$headCell.pos - t.posBeforeNode
      };
    if (e.selection instanceof L)
      return {
        type: "node",
        anchorBlockId: t.node.attrs.id
      };
    {
      const o = _(e.doc, e.selection.head);
      return {
        type: "text",
        anchorBlockId: t.node.attrs.id,
        headBlockId: o.node.attrs.id,
        anchorOffset: e.selection.anchor - t.posBeforeNode,
        headOffset: e.selection.head - o.posBeforeNode
      };
    }
  });
}
function ko(n, e) {
  var s, a;
  const t = (s = E(e.anchorBlockId, n.doc)) == null ? void 0 : s.posBeforeNode;
  if (t === void 0)
    throw new Error(
      `Could not find block with ID ${e.anchorBlockId} to update selection`
    );
  let o;
  if (e.type === "cell")
    o = ne.create(
      n.doc,
      t + e.anchorCellOffset,
      t + e.headCellOffset
    );
  else if (e.type === "node")
    o = L.create(n.doc, t + 1);
  else {
    const r = (a = E(e.headBlockId, n.doc)) == null ? void 0 : a.posBeforeNode;
    if (r === void 0)
      throw new Error(
        `Could not find block with ID ${e.headBlockId} to update selection`
      );
    o = M.create(
      n.doc,
      t + e.anchorOffset,
      r + e.headOffset
    );
  }
  n.setSelection(o);
}
function J(n) {
  return n.map((e) => e.type === "columnList" ? e.children.map((t) => J(t.children)).flat() : {
    ...e,
    children: J(e.children)
  }).flat();
}
function Te(n, e, t) {
  n.transact((o) => {
    var r;
    const s = ((r = n.getSelection()) == null ? void 0 : r.blocks) || [
      n.getTextCursorPosition().block
    ], a = mo(n);
    n.removeBlocks(s), n.insertBlocks(
      J(s),
      e,
      t
    ), ko(o, a);
  });
}
function we(n) {
  return !n || n.type !== "columnList";
}
function Pe(n, e, t) {
  let o, s;
  if (e ? e.children.length > 0 ? (o = e.children[e.children.length - 1], s = "after") : (o = e, s = "before") : t && (o = t, s = "before"), !o || !s)
    return;
  const a = n.getParentBlock(o);
  return we(a) ? { referenceBlock: o, placement: s } : Pe(
    n,
    s === "after" ? o : n.getPrevBlock(o),
    a
  );
}
function ve(n, e, t) {
  let o, s;
  if (e ? e.children.length > 0 ? (o = e.children[0], s = "before") : (o = e, s = "after") : t && (o = t, s = "after"), !o || !s)
    return;
  const a = n.getParentBlock(o);
  return we(a) ? { referenceBlock: o, placement: s } : ve(
    n,
    s === "before" ? o : n.getNextBlock(o),
    a
  );
}
function go(n) {
  n.transact(() => {
    const e = n.getSelection(), t = (e == null ? void 0 : e.blocks[0]) || n.getTextCursorPosition().block, o = Pe(
      n,
      n.getPrevBlock(t),
      n.getParentBlock(t)
    );
    o && Te(
      n,
      o.referenceBlock,
      o.placement
    );
  });
}
function bo(n) {
  n.transact(() => {
    const e = n.getSelection(), t = (e == null ? void 0 : e.blocks[(e == null ? void 0 : e.blocks.length) - 1]) || n.getTextCursorPosition().block, o = ve(
      n,
      n.getNextBlock(t),
      n.getParentBlock(t)
    );
    o && Te(
      n,
      o.referenceBlock,
      o.placement
    );
  });
}
function yo(n, e) {
  const t = typeof e == "string" ? e : e.id, o = S(n), s = E(t, n);
  if (s)
    return b(s.node, o);
}
function So(n, e) {
  const t = typeof e == "string" ? e : e.id, o = E(t, n), s = S(n);
  if (!o)
    return;
  const r = n.resolve(o.posBeforeNode).nodeBefore;
  if (r)
    return b(r, s);
}
function Bo(n, e) {
  const t = typeof e == "string" ? e : e.id, o = E(t, n), s = S(n);
  if (!o)
    return;
  const r = n.resolve(
    o.posBeforeNode + o.node.nodeSize
  ).nodeAfter;
  if (r)
    return b(r, s);
}
function Co(n, e) {
  const t = typeof e == "string" ? e : e.id, o = S(n), s = E(t, n);
  if (!s)
    return;
  const a = n.resolve(s.posBeforeNode), r = a.node(), c = a.node(-1), i = c.type.name !== "doc" ? r.type.name === "blockGroup" ? c : r : void 0;
  if (i)
    return b(i, o);
}
class Eo {
  constructor(e) {
    this.editor = e;
  }
  /**
   * Gets a snapshot of all top-level (non-nested) blocks in the editor.
   * @returns A snapshot of all top-level (non-nested) blocks in the editor.
   */
  get document() {
    return this.editor.transact((e) => Ge(e.doc, this.editor.pmSchema));
  }
  /**
   * Gets a snapshot of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block that should be
   * retrieved.
   * @returns The block that matches the identifier, or `undefined` if no
   * matching block was found.
   */
  getBlock(e) {
    return this.editor.transact((t) => yo(t.doc, e));
  }
  /**
   * Gets a snapshot of the previous sibling of an existing block from the
   * editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * previous sibling should be retrieved.
   * @returns The previous sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the first child/block
   * in the document.
   */
  getPrevBlock(e) {
    return this.editor.transact((t) => So(t.doc, e));
  }
  /**
   * Gets a snapshot of the next sibling of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * next sibling should be retrieved.
   * @returns The next sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the last child/block in
   * the document.
   */
  getNextBlock(e) {
    return this.editor.transact((t) => Bo(t.doc, e));
  }
  /**
   * Gets a snapshot of the parent of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * parent should be retrieved.
   * @returns The parent of the block that matches the identifier. `undefined`
   * if no matching block was found, or the block isn't nested.
   */
  getParentBlock(e) {
    return this.editor.transact(
      (t) => Co(t.doc, e)
    );
  }
  /**
   * Traverses all blocks in the editor depth-first, and executes a callback for each.
   * @param callback The callback to execute for each block. Returning `false` stops the traversal.
   * @param reverse Whether the blocks should be traversed in reverse order.
   */
  forEachBlock(e, t = !1) {
    const o = this.document.slice();
    t && o.reverse();
    function s(a) {
      for (const r of a) {
        if (e(r) === !1)
          return !1;
        const c = t ? r.children.slice().reverse() : r.children;
        if (!s(c))
          return !1;
      }
      return !0;
    }
    s(o);
  }
  /**
   * Inserts new blocks into the editor. If a block's `id` is undefined, BlockNote generates one automatically. Throws an
   * error if the reference block could not be found.
   * @param blocksToInsert An array of partial blocks that should be inserted.
   * @param referenceBlock An identifier for an existing block, at which the new blocks should be inserted.
   * @param placement Whether the blocks should be inserted just before, just after, or nested inside the
   * `referenceBlock`.
   */
  insertBlocks(e, t, o = "before") {
    return this.editor.transact(
      (s) => uo(s, e, t, o)
    );
  }
  /**
   * Updates an existing block in the editor. Since updatedBlock is a PartialBlock object, some fields might not be
   * defined. These undefined fields are kept as-is from the existing block. Throws an error if the block to update could
   * not be found.
   * @param blockToUpdate The block that should be updated.
   * @param update A partial block which defines how the existing block should be changed.
   */
  updateBlock(e, t) {
    return this.editor.transact((o) => et(o, e, t));
  }
  /**
   * Removes existing blocks from the editor. Throws an error if any of the blocks could not be found.
   * @param blocksToRemove An array of identifiers for existing blocks that should be removed.
   */
  removeBlocks(e) {
    return this.editor.transact(
      (t) => le(t, e, []).removedBlocks
    );
  }
  /**
   * Replaces existing blocks in the editor with new blocks. If the blocks that should be removed are not adjacent or
   * are at different nesting levels, `blocksToInsert` will be inserted at the position of the first block in
   * `blocksToRemove`. Throws an error if any of the blocks to remove could not be found.
   * @param blocksToRemove An array of blocks that should be replaced.
   * @param blocksToInsert An array of partial blocks to replace the old ones with.
   */
  replaceBlocks(e, t) {
    return this.editor.transact(
      (o) => le(o, e, t)
    );
  }
  /**
   * Checks if the block containing the text cursor can be nested.
   */
  canNestBlock() {
    return eo(this.editor);
  }
  /**
   * Nests the block containing the text cursor into the block above it.
   */
  nestBlock() {
    Ee(this.editor);
  }
  /**
   * Checks if the block containing the text cursor is nested.
   */
  canUnnestBlock() {
    return to(this.editor);
  }
  /**
   * Lifts the block containing the text cursor out of its parent.
   */
  unnestBlock() {
    Xt(this.editor);
  }
  /**
   * Moves the selected blocks up. If the previous block has children, moves
   * them to the end of its children. If there is no previous block, but the
   * current blocks share a common parent, moves them out of & before it.
   */
  moveBlocksUp() {
    return go(this.editor);
  }
  /**
   * Moves the selected blocks down. If the next block has children, moves
   * them to the start of its children. If there is no next block, but the
   * current blocks share a common parent, moves them out of & after it.
   */
  moveBlocksDown() {
    return bo(this.editor);
  }
}
class xo extends Be {
  constructor(e) {
    super(), this.editor = e, e.on("create", () => {
      e._tiptapEditor.on(
        "update",
        ({ transaction: t, appendedTransactions: o }) => {
          this.emit("onChange", { editor: e, transaction: t, appendedTransactions: o });
        }
      ), e._tiptapEditor.on("selectionUpdate", ({ transaction: t }) => {
        this.emit("onSelectionChange", { editor: e, transaction: t });
      }), e._tiptapEditor.on("mount", () => {
        this.emit("onMount", { editor: e });
      }), e._tiptapEditor.on("unmount", () => {
        this.emit("onUnmount", { editor: e });
      });
    });
  }
  /**
   * Register a callback that will be called when the editor changes.
   */
  onChange(e, t = !0) {
    const o = ({
      transaction: s,
      appendedTransactions: a
    }) => {
      !t && de(s) || e(this.editor, {
        getChanges() {
          return nt(
            s,
            a
          );
        }
      });
    };
    return this.on("onChange", o), () => {
      this.off("onChange", o);
    };
  }
  /**
   * Register a callback that will be called when the selection changes.
   */
  onSelectionChange(e, t = !1) {
    const o = (s) => {
      !t && de(s.transaction) || e(this.editor);
    };
    return this.on("onSelectionChange", o), () => {
      this.off("onSelectionChange", o);
    };
  }
  /**
   * Register a callback that will be called when the editor is mounted.
   */
  onMount(e) {
    return this.on("onMount", e), () => {
      this.off("onMount", e);
    };
  }
  /**
   * Register a callback that will be called when the editor is unmounted.
   */
  onUnmount(e) {
    return this.on("onUnmount", e), () => {
      this.off("onUnmount", e);
    };
  }
}
function de(n) {
  return !!n.getMeta("y-sync$");
}
function Mo(n) {
  return Array.prototype.indexOf.call(n.parentElement.childNodes, n);
}
function To(n) {
  return n.nodeType === 3 && !/\S/.test(n.nodeValue || "");
}
function wo(n) {
  n.querySelectorAll("li > ul, li > ol").forEach((e) => {
    const t = Mo(e), o = e.parentElement, s = Array.from(o.childNodes).slice(
      t + 1
    );
    e.remove(), s.forEach((a) => {
      a.remove();
    }), o.insertAdjacentElement("afterend", e), s.reverse().forEach((a) => {
      if (To(a))
        return;
      const r = document.createElement("li");
      r.append(a), e.insertAdjacentElement("afterend", r);
    }), o.childNodes.length === 0 && o.remove();
  });
}
function Po(n) {
  n.querySelectorAll("li + ul, li + ol").forEach((e) => {
    var a, r;
    const t = e.previousElementSibling, o = document.createElement("div");
    t.insertAdjacentElement("afterend", o), o.append(t);
    const s = document.createElement("div");
    for (s.setAttribute("data-node-type", "blockGroup"), o.append(s); ((a = o.nextElementSibling) == null ? void 0 : a.nodeName) === "UL" || ((r = o.nextElementSibling) == null ? void 0 : r.nodeName) === "OL"; )
      s.append(o.nextElementSibling);
  });
}
let ue = null;
function vo() {
  return ue || (ue = document.implementation.createHTMLDocument("title"));
}
function Io(n) {
  if (typeof n == "string") {
    const e = vo().createElement("div");
    e.innerHTML = n, n = e;
  }
  return wo(n), Po(n), n;
}
function Ie(n, e) {
  const t = Io(n), s = $e.fromSchema(e).parse(t, {
    topNode: e.nodes.blockGroup.create()
  }), a = [];
  for (let r = 0; r < s.childCount; r++)
    a.push(b(s.child(r), e));
  return a;
}
function Ao(n, e) {
  const t = e.value ? e.value : "", o = {};
  e.lang && (o["data-language"] = e.lang);
  let s = {
    type: "element",
    tagName: "code",
    properties: o,
    children: [{ type: "text", value: t }]
  };
  return e.meta && (s.data = { meta: e.meta }), n.patch(e, s), s = n.applyData(e, s), s = {
    type: "element",
    tagName: "pre",
    properties: {},
    children: [s]
  }, n.patch(e, s), s;
}
function _o(n, e) {
  var a;
  const t = String((e == null ? void 0 : e.url) || ""), o = e != null && e.title ? String(e.title) : void 0;
  let s = {
    type: "element",
    tagName: "video",
    properties: {
      src: t,
      "data-name": o,
      "data-url": t,
      controls: !0
    },
    children: []
  };
  return (a = n.patch) == null || a.call(n, e, s), s = n.applyData ? n.applyData(e, s) : s, s;
}
function Ae(n) {
  return Wt().use(Gt).use(zt).use(Rt, {
    handlers: {
      ...ie,
      image: (t, o) => {
        const s = String((o == null ? void 0 : o.url) || "");
        return tt(s) ? _o(t, o) : ie.image(t, o);
      },
      code: Ao
    }
  }).use(jt).processSync(n).value;
}
function Do(n, e) {
  const t = Ae(n);
  return Ie(t, e);
}
class Lo {
  constructor(e) {
    this.editor = e;
  }
  /**
   * Exports blocks into a simplified HTML string. To better conform to HTML standards, children of blocks which aren't list
   * items are un-nested in the output HTML.
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToHTMLLossy(e = this.editor.document) {
    return Se(
      this.editor.pmSchema,
      this.editor
    ).exportBlocks(e, {});
  }
  /**
   * Serializes blocks into an HTML string in the format that would normally be rendered by the editor.
   *
   * Use this method if you want to server-side render HTML (for example, a blog post that has been edited in BlockNote)
   * and serve it to users without loading the editor on the client (i.e.: displaying the blog post)
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToFullHTML(e = this.editor.document) {
    return ho(
      this.editor.pmSchema,
      this.editor
    ).serializeBlocks(e, {});
  }
  /**
   * Parses blocks from an HTML string. Tries to create `Block` objects out of any HTML block-level elements, and
   * `InlineNode` objects from any HTML inline elements, though not all element types are recognized. If BlockNote
   * doesn't recognize an HTML element's tag, it will parse it as a paragraph or plain text.
   * @param html The HTML string to parse blocks from.
   * @returns The blocks parsed from the HTML string.
   */
  tryParseHTMLToBlocks(e) {
    return Ie(e, this.editor.pmSchema);
  }
  /**
   * Serializes blocks into a Markdown string. The output is simplified as Markdown does not support all features of
   * BlockNote - children of blocks which aren't list items are un-nested and certain styles are removed.
   * @param blocks An array of blocks that should be serialized into Markdown.
   * @returns The blocks, serialized as a Markdown string.
   */
  blocksToMarkdownLossy(e = this.editor.document) {
    return st(e, this.editor.pmSchema, this.editor, {});
  }
  /**
   * Creates a list of blocks from a Markdown string. Tries to create `Block` and `InlineNode` objects based on
   * Markdown syntax, though not all symbols are recognized. If BlockNote doesn't recognize a symbol, it will parse it
   * as text.
   * @param markdown The Markdown string to parse blocks from.
   * @returns The blocks parsed from the Markdown string.
   */
  tryParseMarkdownToBlocks(e) {
    return Do(e, this.editor.pmSchema);
  }
  /**
   * Paste HTML into the editor. Defaults to converting HTML to BlockNote HTML.
   * @param html The HTML to paste.
   * @param raw Whether to paste the HTML as is, or to convert it to BlockNote HTML.
   */
  pasteHTML(e, t = !1) {
    var s;
    let o = e;
    if (!t) {
      const a = this.tryParseHTMLToBlocks(e);
      o = this.blocksToFullHTML(a);
    }
    o && ((s = this.editor.prosemirrorView) == null || s.pasteHTML(o));
  }
  /**
   * Paste text into the editor. Defaults to interpreting text as markdown.
   * @param text The text to paste.
   */
  pasteText(e) {
    var t;
    return (t = this.editor.prosemirrorView) == null ? void 0 : t.pasteText(e);
  }
  /**
   * Paste markdown into the editor.
   * @param markdown The markdown to paste.
   */
  pasteMarkdown(e) {
    const t = Ae(e);
    return this.pasteHTML(t);
  }
}
const se = [
  "vscode-editor-data",
  "blocknote/html",
  "text/markdown",
  "text/html",
  "text/plain",
  "Files"
];
function No(n, e) {
  if (!n.startsWith(".") || !e.startsWith("."))
    throw new Error("The strings provided are not valid file extensions.");
  return n === e;
}
function Oo(n, e) {
  const t = n.split("/"), o = e.split("/");
  if (t.length !== 2)
    throw new Error(`The string ${n} is not a valid MIME type.`);
  if (o.length !== 2)
    throw new Error(`The string ${e} is not a valid MIME type.`);
  return t[1] === "*" || o[1] === "*" ? t[0] === o[0] : (t[0] === "*" || o[0] === "*" || t[0] === o[0]) && t[1] === o[1];
}
function pe(n, e, t, o = "after") {
  let s;
  return Array.isArray(e.content) && e.content.length === 0 ? s = n.updateBlock(e, t).id : s = n.insertBlocks(
    [t],
    e,
    o
  )[0].id, s;
}
async function _e(n, e) {
  var a;
  if (!e.uploadFile) {
    console.warn(
      "Attempted ot insert file, but uploadFile is not set in the BlockNote editor options"
    );
    return;
  }
  const t = "dataTransfer" in n ? n.dataTransfer : n.clipboardData;
  if (t === null)
    return;
  let o = null;
  for (const r of se)
    if (t.types.includes(r)) {
      o = r;
      break;
    }
  if (o !== "Files")
    return;
  const s = t.items;
  if (s) {
    n.preventDefault();
    for (let r = 0; r < s.length; r++) {
      let c = "file";
      for (const l of Object.values(e.schema.blockSpecs))
        for (const d of ((a = l.implementation.meta) == null ? void 0 : a.fileBlockAccept) || []) {
          const u = d.startsWith("."), p = s[r].getAsFile();
          if (p && (!u && p.type && Oo(s[r].type, d) || u && No(
            "." + p.name.split(".").pop(),
            d
          ))) {
            c = l.config.type;
            break;
          }
        }
      const i = s[r].getAsFile();
      if (i) {
        const l = {
          type: c,
          props: {
            name: i.name
          }
        };
        let d;
        if (n.type === "paste") {
          const h = e.getTextCursorPosition().block;
          d = pe(e, h, l);
        } else if (n.type === "drop") {
          const h = {
            left: n.clientX,
            top: n.clientY
          }, f = e.prosemirrorView.posAtCoords(h);
          if (!f)
            return;
          d = e.transact((k) => {
            const g = _(k.doc, f.pos), B = e.prosemirrorView.dom.querySelector(
              `[data-id="${g.node.attrs.id}"]`
            ), w = B == null ? void 0 : B.getBoundingClientRect();
            return pe(
              e,
              e.getBlock(g.node.attrs.id),
              l,
              w && (w.top + w.bottom) / 2 > h.top ? "before" : "after"
            );
          });
        } else
          return;
        const u = await e.uploadFile(i, d), p = typeof u == "string" ? {
          props: {
            url: u
          }
        } : { ...u };
        e.updateBlock(d, p);
      }
    }
  }
}
const Fo = (n) => x.create({
  name: "dropFile",
  addProseMirrorPlugins() {
    return [
      new oe({
        props: {
          handleDOMEvents: {
            drop(e, t) {
              if (!n.isEditable)
                return;
              let o = null;
              for (const s of se)
                if (t.dataTransfer.types.includes(s)) {
                  o = s;
                  break;
                }
              return o === null ? !0 : o === "Files" ? (_e(t, n), !0) : !1;
            }
          }
        }
      })
    ];
  }
}), Ho = /(^|\n) {0,3}#{1,6} {1,8}[^\n]{1,64}\r?\n\r?\n\s{0,32}\S/, $o = /(_|__|\*|\*\*|~~|==|\+\+)(?!\s)(?:[^\s](?:.{0,62}[^\s])?|\S)(?=\1)/, Vo = /\[[^\]]{1,128}\]\(https?:\/\/\S{1,999}\)/, Uo = /(?:\s|^)`(?!\s)(?:[^\s`](?:[^`]{0,46}[^\s`])?|[^\s`])`([^\w]|$)/, zo = /(?:^|\n)\s{0,5}-\s{1}[^\n]+\n\s{0,15}-\s/, Go = /(?:^|\n)\s{0,5}\d+\.\s{1}[^\n]+\n\s{0,15}\d+\.\s/, Ro = /\n{2} {0,3}-{2,48}\n{2}/, jo = /(?:\n|^)(```|~~~|\$\$)(?!`|~)[^\s]{0,64} {0,64}[^\n]{0,64}\n[\s\S]{0,9999}?\s*\1 {0,64}(?:\n+|$)/, Wo = /(?:\n|^)(?!\s)\w[^\n]{0,64}\r?\n(-|=)\1{0,64}\n\n\s{0,64}(\w|$)/, Ko = /(?:^|(\r?\n\r?\n))( {0,3}>[^\n]{1,333}\n){1,999}($|(\r?\n))/, Jo = /^\s*\|(.+\|)+\s*$/m, Yo = /^\s*\|(\s*[-:]+[-:]\s*\|)+\s*$/m, qo = /^\s*\|(.+\|)+\s*$/m, Zo = (n) => Ho.test(n) || $o.test(n) || Vo.test(n) || Uo.test(n) || zo.test(n) || Go.test(n) || Ro.test(n) || jo.test(n) || Wo.test(n) || Ko.test(n) || Jo.test(n) || Yo.test(n) || qo.test(n);
async function Qo(n, e) {
  const { schema: t } = e.state;
  if (!n.clipboardData)
    return !1;
  const o = n.clipboardData.getData("text/plain");
  if (!o)
    return !1;
  if (!t.nodes.codeBlock)
    return e.pasteText(o), !0;
  const s = n.clipboardData.getData("vscode-editor-data"), a = s ? JSON.parse(s) : void 0, r = a == null ? void 0 : a.mode;
  return r ? (e.pasteHTML(
    `<pre><code class="language-${r}">${o.replace(
      /\r\n?/g,
      `
`
    )}</code></pre>`
  ), !0) : !1;
}
function Xo({
  event: n,
  editor: e,
  prioritizeMarkdownOverHTML: t,
  plainTextAsMarkdown: o
}) {
  var c;
  if (e.transact(
    (i) => i.selection.$from.parent.type.spec.code && i.selection.$to.parent.type.spec.code
  )) {
    const i = (c = n.clipboardData) == null ? void 0 : c.getData("text/plain");
    if (i)
      return e.pasteText(i), !0;
  }
  let a;
  for (const i of se)
    if (n.clipboardData.types.includes(i)) {
      a = i;
      break;
    }
  if (!a)
    return !0;
  if (a === "vscode-editor-data")
    return Qo(n, e.prosemirrorView), !0;
  if (a === "Files")
    return _e(n, e), !0;
  const r = n.clipboardData.getData(a);
  if (a === "blocknote/html")
    return e.pasteHTML(r, !0), !0;
  if (a === "text/markdown")
    return e.pasteMarkdown(r), !0;
  if (t) {
    const i = n.clipboardData.getData("text/plain");
    if (Zo(i))
      return e.pasteMarkdown(i), !0;
  }
  return a === "text/html" ? (e.pasteHTML(r), !0) : o ? (e.pasteMarkdown(r), !0) : (e.pasteText(r), !0);
}
const en = (n, e) => x.create({
  name: "pasteFromClipboard",
  addProseMirrorPlugins() {
    return [
      new oe({
        props: {
          handleDOMEvents: {
            paste(t, o) {
              if (o.preventDefault(), !!n.isEditable)
                return e({
                  event: o,
                  editor: n,
                  defaultPasteHandler: ({
                    prioritizeMarkdownOverHTML: s = !0,
                    plainTextAsMarkdown: a = !0
                  } = {}) => Xo({
                    event: o,
                    editor: n,
                    prioritizeMarkdownOverHTML: s,
                    plainTextAsMarkdown: a
                  })
                });
            }
          }
        }
      })
    ];
  }
});
function tn(n, e, t) {
  var c;
  let o = !1;
  const s = n.state.selection instanceof ne;
  if (!s) {
    const i = n.state.doc.slice(
      n.state.selection.from,
      n.state.selection.to,
      !1
    ).content, l = [];
    for (let d = 0; d < i.childCount; d++)
      l.push(i.child(d));
    o = l.find(
      (d) => d.type.isInGroup("bnBlock") || d.type.name === "blockGroup" || d.type.spec.group === "blockContent"
    ) === void 0, o && (e = i);
  }
  let a;
  const r = Se(
    n.state.schema,
    t
  );
  if (s) {
    ((c = e.firstChild) == null ? void 0 : c.type.name) === "table" && (e = e.firstChild.content);
    const i = Re(
      e,
      t.schema.inlineContentSchema,
      t.schema.styleSchema
    );
    a = `<table>${r.exportInlineContent(
      i,
      {}
    )}</table>`;
  } else if (o) {
    const i = je(
      e,
      t.schema.inlineContentSchema,
      t.schema.styleSchema
    );
    a = r.exportInlineContent(i, {});
  } else {
    const i = at(e);
    a = r.exportBlocks(i, {});
  }
  return a;
}
function De(n, e) {
  "node" in n.state.selection && n.state.selection.node.type.spec.group === "blockContent" && e.transact(
    (r) => r.setSelection(
      new L(r.doc.resolve(n.state.selection.from - 1))
    )
  );
  const t = n.serializeForClipboard(
    n.state.selection.content()
  ).dom.innerHTML, o = n.state.selection.content().content, s = tn(
    n,
    o,
    e
  ), a = rt(s);
  return { clipboardHTML: t, externalHTML: s, markdown: a };
}
const fe = () => {
  const n = window.getSelection();
  if (!n || n.isCollapsed)
    return !0;
  let e = n.focusNode;
  for (; e; ) {
    if (e instanceof HTMLElement && e.getAttribute("contenteditable") === "false")
      return !0;
    e = e.parentElement;
  }
  return !1;
}, he = (n, e, t) => {
  t.preventDefault(), t.clipboardData.clearData();
  const { clipboardHTML: o, externalHTML: s, markdown: a } = De(
    e,
    n
  );
  t.clipboardData.setData("blocknote/html", o), t.clipboardData.setData("text/html", s), t.clipboardData.setData("text/plain", a);
}, on = (n) => x.create({
  name: "copyToClipboard",
  addProseMirrorPlugins() {
    return [
      new oe({
        props: {
          handleDOMEvents: {
            copy(e, t) {
              return fe() || he(n, e, t), !0;
            },
            cut(e, t) {
              return fe() || (he(n, e, t), e.editable && e.dispatch(e.state.tr.deleteSelection())), !0;
            },
            // This is for the use-case in which only a block without content
            // is selected, e.g. an image block, and dragged (not using the
            // drag handle).
            dragstart(e, t) {
              if (!("node" in e.state.selection) || e.state.selection.node.type.spec.group !== "blockContent")
                return;
              n.transact(
                (r) => r.setSelection(
                  new L(
                    r.doc.resolve(e.state.selection.from - 1)
                  )
                )
              ), t.preventDefault(), t.dataTransfer.clearData();
              const { clipboardHTML: o, externalHTML: s, markdown: a } = De(e, n);
              return t.dataTransfer.setData("blocknote/html", o), t.dataTransfer.setData("text/html", s), t.dataTransfer.setData("text/plain", a), !0;
            }
          }
        }
      })
    ];
  }
}), nn = {
  blockColor: "data-block-color",
  blockStyle: "data-block-style",
  id: "data-id",
  depth: "data-depth",
  depthChange: "data-depth-change"
}, sn = D.create({
  name: "blockContainer",
  group: "blockGroupChild bnBlock",
  // A block always contains content, and optionally a blockGroup which contains nested blocks
  content: "blockContent blockGroup?",
  // Ensures content-specific keyboard handlers trigger first.
  priority: 50,
  defining: !0,
  marks: "insertion modification deletion",
  parseHTML() {
    return [
      {
        tag: "div[data-node-type=" + this.name + "]",
        getAttrs: (n) => {
          if (typeof n == "string")
            return !1;
          const e = {};
          for (const [t, o] of Object.entries(nn))
            n.getAttribute(o) && (e[t] = n.getAttribute(o));
          return e;
        }
      },
      // Ignore `blockOuter` divs, but parse the `blockContainer` divs inside them.
      {
        tag: 'div[data-node-type="blockOuter"]',
        skip: !0
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    var s;
    const e = document.createElement("div");
    e.className = "bn-block-outer", e.setAttribute("data-node-type", "blockOuter");
    for (const [a, r] of Object.entries(n))
      a !== "class" && e.setAttribute(a, r);
    const t = {
      ...((s = this.options.domAttributes) == null ? void 0 : s.block) || {},
      ...n
    }, o = document.createElement("div");
    o.className = X("bn-block", t.class), o.setAttribute("data-node-type", this.name);
    for (const [a, r] of Object.entries(t))
      a !== "class" && o.setAttribute(a, r);
    return e.appendChild(o), {
      dom: e,
      contentDOM: o
    };
  }
}), rn = D.create({
  name: "blockGroup",
  group: "childContainer",
  content: "blockGroupChild+",
  marks: "deletion insertion modification",
  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (n) => typeof n == "string" ? !1 : n.getAttribute("data-node-type") === "blockGroup" ? null : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    var o;
    const e = {
      ...((o = this.options.domAttributes) == null ? void 0 : o.blockGroup) || {},
      ...n
    }, t = document.createElement("div");
    t.className = X(
      "bn-block-group",
      e.class
    ), t.setAttribute("data-node-type", "blockGroup");
    for (const [s, a] of Object.entries(e))
      s !== "class" && t.setAttribute(s, a);
    return {
      dom: t,
      contentDOM: t
    };
  }
}), an = D.create({
  name: "doc",
  topNode: !0,
  content: "blockGroup",
  marks: "insertion modification deletion"
});
let me = !1;
function cn(n, e) {
  const t = [
    I.ClipboardTextSerializer,
    I.Commands,
    I.Editable,
    I.FocusEvents,
    I.Tabindex,
    Ht,
    ge.configure({
      // everything from bnBlock group (nodes that represent a BlockNote block should have an id)
      types: ["blockContainer", "columnList", "column"],
      setIdAttribute: e.setIdAttribute
    }),
    Yt,
    Vt,
    // marks:
    so,
    ro,
    ao,
    $t.extend({
      inclusive: !1
    }).configure({
      defaultProtocol: Et,
      // only call this once if we have multiple editors installed. Or fix https://github.com/ueberdosis/tiptap/issues/5450
      protocols: me ? [] : Ct
    }),
    ...Object.values(n.schema.styleSpecs).map((o) => o.implementation.mark.configure({
      editor: n
    })),
    co,
    Jt,
    io,
    // make sure escape blurs editor, so that we can tab to other elements in the host page (accessibility)
    x.create({
      name: "OverrideEscape",
      addKeyboardShortcuts: () => ({
        Escape: () => {
          var o;
          return (o = n.getExtension(ye)) != null && o.shown() ? !1 : (n.blur(), !0);
        }
      })
    }),
    // nodes
    an,
    sn.configure({
      editor: n,
      domAttributes: e.domAttributes
    }),
    no.configure({
      editor: n,
      tabBehavior: e.tabBehavior
    }),
    rn.configure({
      domAttributes: e.domAttributes
    }),
    ...Object.values(n.schema.inlineContentSpecs).filter((o) => o.config !== "link" && o.config !== "text").map((o) => o.implementation.node.configure({
      editor: n
    })),
    ...Object.values(n.schema.blockSpecs).flatMap((o) => [
      // the node extension implementations
      ..."node" in o.implementation ? [
        o.implementation.node.configure({
          editor: n,
          domAttributes: e.domAttributes
        })
      ] : []
    ]),
    on(n),
    en(
      n,
      e.pasteHandler || ((o) => o.defaultPasteHandler())
    ),
    Fo(n)
  ];
  return me = !0, t;
}
function ln(n, e) {
  var o;
  const t = [
    it(),
    ct(e),
    G(e),
    R(e),
    lt(e),
    dt(),
    ut(e),
    Ut(e),
    pt(e),
    ye(e),
    ...e.trailingBlock !== !1 ? [ft()] : []
  ];
  return e.collaboration ? (t.push(ht(e.collaboration)), (o = e.collaboration.provider) != null && o.awareness && t.push(mt(e.collaboration)), t.push(kt(e.collaboration)), t.push(gt(e.collaboration)), t.push(bt(e.collaboration))) : t.push(yt()), "table" in n.schema.blockSpecs && t.push(St(e)), e.animations !== !1 && t.push(Bt()), t;
}
class dn {
  constructor(e, t) {
    /**
     * A set of extension keys which are disabled by the options
     */
    m(this, "disabledExtensions", /* @__PURE__ */ new Set());
    /**
     * A list of all the extensions that are registered to the editor
     */
    m(this, "extensions", []);
    /**
     * A map of all the abort controllers for each extension that has an init method defined
     */
    m(this, "abortMap", /* @__PURE__ */ new Map());
    /**
     * A map of all the extension factories that are registered to the editor
     */
    m(this, "extensionFactories", /* @__PURE__ */ new Map());
    /**
     * Because a single blocknote extension can both have it's own prosemirror plugins & additional generated ones (e.g. keymap & input rules plugins)
     * We need to keep track of all the plugins for each extension, so that we can remove them when the extension is unregistered
     */
    m(this, "extensionPlugins", /* @__PURE__ */ new Map());
    this.editor = e, this.options = t, e.onMount(() => {
      for (const o of this.extensions)
        if (o.mount) {
          const s = new window.AbortController(), a = o.mount({
            dom: e.prosemirrorView.dom,
            root: e.prosemirrorView.root,
            signal: s.signal
          });
          a && s.signal.addEventListener("abort", () => {
            a();
          }), this.abortMap.set(o, s);
        }
    }), e.onUnmount(() => {
      for (const [o, s] of this.abortMap.entries())
        this.abortMap.delete(o), s.abort();
    }), this.disabledExtensions = new Set(t.disableExtensions || []);
    for (const o of ln(this.editor, this.options))
      this.addExtension(o);
    for (const o of this.options.extensions ?? [])
      this.addExtension(o);
    for (const o of Object.values(this.editor.schema.blockSpecs))
      for (const s of o.extensions ?? [])
        this.addExtension(s);
  }
  /**
   * Register one or more extensions to the editor after the editor is initialized.
   *
   * This allows users to switch on & off extensions "at runtime".
   */
  registerExtension(e) {
    var a;
    const t = [].concat(e).filter(Boolean);
    if (!t.length) {
      console.warn("No extensions found to register", e);
      return;
    }
    const o = t.map((r) => this.addExtension(r)).filter(Boolean), s = /* @__PURE__ */ new Set();
    for (const r of o)
      r != null && r.tiptapExtensions && console.warn(
        `Extension ${r.key} has tiptap extensions, but these cannot be changed after initializing the editor. Please separate the extension into multiple extensions if you want to add them, or re-initialize the editor.`,
        r
      ), (a = r == null ? void 0 : r.inputRules) != null && a.length && console.warn(
        `Extension ${r.key} has input rules, but these cannot be changed after initializing the editor. Please separate the extension into multiple extensions if you want to add them, or re-initialize the editor.`,
        r
      ), this.getProsemirrorPluginsFromExtension(r).plugins.forEach(
        (c) => {
          s.add(c);
        }
      );
    this.updatePlugins((r) => [...r, ...s]);
  }
  /**
   * Register an extension to the editor
   * @param extension - The extension to register
   * @returns The extension instance
   */
  addExtension(e) {
    let t;
    if (typeof e == "function" ? t = e({ editor: this.editor }) : t = e, !(!t || this.disabledExtensions.has(t.key))) {
      if (typeof e == "function") {
        const o = t[Ft];
        typeof o == "function" && this.extensionFactories.set(o, t);
      }
      return this.extensions.push(t), t;
    }
  }
  /**
   * Resolve an extension or a list of extensions into a list of extension instances
   * @param toResolve - The extension or list of extensions to resolve
   * @returns A list of extension instances
   */
  resolveExtensions(e) {
    const t = [];
    if (typeof e == "function") {
      const o = this.extensionFactories.get(e);
      o && t.push(o);
    } else if (Array.isArray(e))
      for (const o of e)
        t.push(...this.resolveExtensions(o));
    else if (typeof e == "object" && "key" in e)
      t.push(e);
    else if (typeof e == "string") {
      const o = this.extensions.find((s) => s.key === e);
      o && t.push(o);
    }
    return t;
  }
  /**
   * Unregister an extension from the editor
   * @param toUnregister - The extension to unregister
   * @returns void
   */
  unregisterExtension(e) {
    var a;
    const t = this.resolveExtensions(e);
    if (!t.length) {
      console.warn("No extensions found to unregister", e);
      return;
    }
    let o = !1;
    const s = /* @__PURE__ */ new Set();
    for (const r of t) {
      this.extensions = this.extensions.filter((i) => i !== r), this.extensionFactories.forEach((i, l) => {
        i === r && this.extensionFactories.delete(l);
      }), (a = this.abortMap.get(r)) == null || a.abort(), this.abortMap.delete(r);
      const c = this.extensionPlugins.get(r);
      c == null || c.forEach((i) => {
        s.add(i);
      }), this.extensionPlugins.delete(r), r.tiptapExtensions && !o && (o = !0, console.warn(
        `Extension ${r.key} has tiptap extensions, but they will not be removed. Please separate the extension into multiple extensions if you want to remove them, or re-initialize the editor.`,
        e
      ));
    }
    this.updatePlugins(
      (r) => r.filter((c) => !s.has(c))
    );
  }
  /**
   * Allows resetting the current prosemirror state's plugins
   * @param update - A function that takes the current plugins and returns the new plugins
   * @returns void
   */
  updatePlugins(e) {
    const t = this.editor.prosemirrorState, o = t.reconfigure({
      plugins: e(t.plugins.slice())
    });
    this.editor.prosemirrorView.updateState(o);
  }
  /**
   * Get all the extensions that are registered to the editor
   */
  getTiptapExtensions() {
    var s;
    const e = cn(
      this.editor,
      this.options
    ), t = xt(this.extensions), o = /* @__PURE__ */ new Map();
    for (const a of this.extensions) {
      a.tiptapExtensions && e.push(...a.tiptapExtensions);
      const r = t(a.key), { plugins: c, inputRules: i } = this.getProsemirrorPluginsFromExtension(a);
      c.length && e.push(
        x.create({
          name: a.key,
          priority: r,
          addProseMirrorPlugins: () => c
        })
      ), i.length && (o.has(r) || o.set(r, []), o.get(r).push(...i));
    }
    e.push(
      x.create({
        name: "blocknote-input-rules",
        addProseMirrorPlugins() {
          const a = [];
          return Array.from(o.keys()).sort().reverse().forEach((r) => {
            a.push(...o.get(r));
          }), [Lt({ rules: a })];
        }
      })
    );
    for (const a of ((s = this.options._tiptapOptions) == null ? void 0 : s.extensions) ?? [])
      e.push(a);
    return e;
  }
  /**
   * This maps a blocknote extension into an array of Prosemirror plugins if it has any of the following:
   * - plugins
   * - keyboard shortcuts
   * - input rules
   */
  getProsemirrorPluginsFromExtension(e) {
    var s, a, r;
    const t = [...e.prosemirrorPlugins ?? []], o = [];
    return !((s = e.prosemirrorPlugins) != null && s.length) && !Object.keys(e.keyboardShortcuts || {}).length && !((a = e.inputRules) != null && a.length) ? { plugins: t, inputRules: o } : (this.extensionPlugins.set(e, t), (r = e.inputRules) != null && r.length && o.push(
      ...e.inputRules.map((c) => new Nt(c.find, (i, l, d, u) => {
        const p = c.replace({
          match: l,
          range: { from: d, to: u },
          editor: this.editor
        });
        if (p) {
          const h = this.editor.getTextCursorPosition();
          if (this.editor.schema.blockSchema[h.block.type].content !== "inline")
            return null;
          const f = F(i.tr), k = i.tr.deleteRange(d, u);
          return ot(k, f.bnBlock.beforePos, p), k;
        }
        return null;
      }))
    ), Object.keys(e.keyboardShortcuts || {}).length && t.push(
      Ot(
        Object.fromEntries(
          Object.entries(e.keyboardShortcuts).map(([c, i]) => [
            c,
            () => i({ editor: this.editor })
          ])
        )
      )
    ), { plugins: t, inputRules: o });
  }
  /**
   * Get all extensions
   */
  getExtensions() {
    return new Map(
      this.extensions.map((e) => [e.key, e])
    );
  }
  getExtension(e) {
    if (typeof e == "string") {
      const t = this.extensions.find((o) => o.key === e);
      return t || void 0;
    } else if (typeof e == "function") {
      const t = this.extensionFactories.get(e);
      return t || void 0;
    }
    throw new Error(`Invalid extension type: ${typeof e}`);
  }
  /**
   * Check if an extension exists
   */
  hasExtension(e) {
    return typeof e == "string" ? this.extensions.some((t) => t.key === e) : typeof e == "object" && "key" in e ? this.extensions.some((t) => t.key === e.key) : typeof e == "function" ? this.extensionFactories.has(e) : !1;
  }
}
function un(n) {
  const e = S(n);
  if (n.selection.empty || "node" in n.selection)
    return;
  const t = n.doc.resolve(
    _(n.doc, n.selection.from).posBeforeNode
  ), o = n.doc.resolve(
    _(n.doc, n.selection.to).posBeforeNode
  ), s = (l, d) => {
    const u = t.posAtIndex(l, d), p = n.doc.resolve(u).nodeAfter;
    if (!p)
      throw new Error(
        `Error getting selection - node not found at position ${u}`
      );
    return b(p, e);
  }, a = [], r = t.sharedDepth(o.pos), c = t.index(r), i = o.index(r);
  if (t.depth > r) {
    a.push(b(t.nodeAfter, e));
    for (let l = t.depth; l > r; l--)
      if (t.node(l).type.isInGroup("childContainer")) {
        const u = t.index(l) + 1, p = t.node(l).childCount;
        for (let h = u; h < p; h++)
          a.push(s(h, l));
      }
  } else
    a.push(s(c, r));
  for (let l = c + 1; l <= i; l++)
    a.push(s(l, r));
  if (a.length === 0)
    throw new Error(
      `Error getting selection - selection doesn't span any blocks (${n.selection})`
    );
  return {
    blocks: a
  };
}
function pn(n, e, t) {
  const o = typeof e == "string" ? e : e.id, s = typeof t == "string" ? t : t.id, a = S(n), r = H(a);
  if (o === s)
    throw new Error(
      `Attempting to set selection with the same anchor and head blocks (id ${o})`
    );
  const c = E(o, n.doc);
  if (!c)
    throw new Error(`Block with ID ${o} not found`);
  const i = E(s, n.doc);
  if (!i)
    throw new Error(`Block with ID ${s} not found`);
  const l = z(c), d = z(i), u = r.blockSchema[l.blockNoteType], p = r.blockSchema[d.blockNoteType];
  if (!l.isBlockContainer || u.content === "none")
    throw new Error(
      `Attempting to set selection anchor in block without content (id ${o})`
    );
  if (!d.isBlockContainer || p.content === "none")
    throw new Error(
      `Attempting to set selection anchor in block without content (id ${s})`
    );
  let h, f;
  if (u.content === "table") {
    const k = ae.get(l.blockContent.node);
    h = l.blockContent.beforePos + k.positionAt(0, 0, l.blockContent.node) + 1 + 2;
  } else
    h = l.blockContent.beforePos + 1;
  if (p.content === "table") {
    const k = ae.get(d.blockContent.node), g = d.blockContent.beforePos + k.positionAt(
      k.height - 1,
      k.width - 1,
      d.blockContent.node
    ) + 1, B = n.doc.resolve(g).nodeAfter.nodeSize;
    f = g + B - 2;
  } else
    f = d.blockContent.afterPos - 1;
  n.setSelection(M.create(n.doc, h, f));
}
function fn(n) {
  const e = S(n);
  let t = n.selection.$from, o = n.selection.$to;
  for (; o.parentOffset >= o.parent.nodeSize - 2 && o.depth > 0; )
    o = n.doc.resolve(o.pos + 1);
  for (; o.parentOffset === 0 && o.depth > 0; )
    o = n.doc.resolve(o.pos - 1);
  for (; t.parentOffset === 0 && t.depth > 0; )
    t = n.doc.resolve(t.pos - 1);
  for (; t.parentOffset >= t.parent.nodeSize - 2 && t.depth > 0; )
    t = n.doc.resolve(t.pos + 1);
  const s = We(
    n.doc.slice(t.pos, o.pos, !0),
    e
  );
  return {
    _meta: {
      startPos: t.pos,
      endPos: o.pos
    },
    ...s
  };
}
function hn(n) {
  const { bnBlock: e } = F(n), t = S(n.doc), o = n.doc.resolve(e.beforePos), s = o.nodeBefore, a = n.doc.resolve(e.afterPos).nodeAfter;
  let r;
  return o.depth > 1 && (r = o.node(), r.type.isInGroup("bnBlock") || (r = o.node(o.depth - 1))), {
    block: b(e.node, t),
    prevBlock: s === null ? void 0 : b(s, t),
    nextBlock: a === null ? void 0 : b(a, t),
    parentBlock: r === void 0 ? void 0 : b(r, t)
  };
}
function Le(n, e, t = "start") {
  const o = typeof e == "string" ? e : e.id, s = S(n.doc), a = H(s), r = E(o, n.doc);
  if (!r)
    throw new Error(`Block with ID ${o} not found`);
  const c = z(r), i = a.blockSchema[c.blockNoteType].content;
  if (c.isBlockContainer) {
    const l = c.blockContent;
    if (i === "none") {
      n.setSelection(L.create(n.doc, l.beforePos));
      return;
    }
    if (i === "inline")
      t === "start" ? n.setSelection(
        M.create(n.doc, l.beforePos + 1)
      ) : n.setSelection(
        M.create(n.doc, l.afterPos - 1)
      );
    else if (i === "table")
      t === "start" ? n.setSelection(
        M.create(n.doc, l.beforePos + 4)
      ) : n.setSelection(
        M.create(n.doc, l.afterPos - 4)
      );
    else
      throw new O(i);
  } else {
    const l = t === "start" ? c.childContainer.node.firstChild : c.childContainer.node.lastChild;
    Le(n, l.attrs.id, t);
  }
}
class mn {
  constructor(e) {
    this.editor = e;
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned data will contain the entire block.
   */
  getSelection() {
    return this.editor.transact((e) => un(e));
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned block will be
   * only the part of the block that is included in the selection.
   */
  getSelectionCutBlocks() {
    return this.editor.transact((e) => fn(e));
  }
  /**
   * Sets the selection to a range of blocks.
   * @param startBlock The identifier of the block that should be the start of the selection.
   * @param endBlock The identifier of the block that should be the end of the selection.
   */
  setSelection(e, t) {
    return this.editor.transact((o) => pn(o, e, t));
  }
  /**
   * Gets a snapshot of the current text cursor position.
   * @returns A snapshot of the current text cursor position.
   */
  getTextCursorPosition() {
    return this.editor.transact((e) => hn(e));
  }
  /**
   * Sets the text cursor position to the start or end of an existing block. Throws an error if the target block could
   * not be found.
   * @param targetBlock The identifier of an existing block that the text cursor should be moved to.
   * @param placement Whether the text cursor should be placed at the start or end of the block.
   */
  setTextCursorPosition(e, t = "start") {
    return this.editor.transact(
      (o) => Le(o, e, t)
    );
  }
  /**
   * Gets the bounding box of the current selection.
   */
  getSelectionBoundingBox() {
    if (!this.editor.prosemirrorView)
      return;
    const { selection: e } = this.editor.prosemirrorState, { ranges: t } = e, o = Math.min(...t.map((a) => a.$from.pos)), s = Math.max(...t.map((a) => a.$to.pos));
    if (wt(e)) {
      const a = this.editor.prosemirrorView.nodeDOM(o);
      if (a)
        return a.getBoundingClientRect();
    }
    return Pt(
      this.editor.prosemirrorView,
      o,
      s
    ).toJSON();
  }
}
class kn {
  constructor(e) {
    /**
     * Stores the currently active transaction, which is the accumulated transaction from all {@link dispatch} calls during a {@link transact} calls
     */
    m(this, "activeTransaction", null);
    // Flag to indicate if we're in a `can` call
    m(this, "isInCan", !1);
    this.editor = e;
  }
  /**
   * For any command that can be executed, you can check if it can be executed by calling `editor.can(command)`.
   * @example
   * ```ts
   * if (editor.can(editor.undo)) {
   *   // show button
   * } else {
   *   // hide button
   * }
   */
  can(e) {
    try {
      return this.isInCan = !0, e();
    } finally {
      this.isInCan = !1;
    }
  }
  /**
   * Execute a prosemirror command. This is mostly for backwards compatibility with older code.
   *
   * @note You should prefer the {@link transact} method when possible, as it will automatically handle the dispatching of the transaction and work across blocknote transactions.
   *
   * @example
   * ```ts
   * editor.exec((state, dispatch, view) => {
   *   dispatch(state.tr.insertText("Hello, world!"));
   * });
   * ```
   */
  exec(e) {
    if (this.activeTransaction)
      throw new Error(
        "`exec` should not be called within a `transact` call, move the `exec` call outside of the `transact` call"
      );
    if (this.isInCan)
      return this.canExec(e);
    const t = this.prosemirrorState, o = this.prosemirrorView;
    return e(t, (a) => this.prosemirrorView.dispatch(a), o);
  }
  /**
   * Check if a command can be executed. A command should return `false` if it is not valid in the current state.
   *
   * @example
   * ```ts
   * if (editor.canExec(command)) {
   *   // show button
   * } else {
   *   // hide button
   * }
   * ```
   */
  canExec(e) {
    if (this.activeTransaction)
      throw new Error(
        "`canExec` should not be called within a `transact` call, move the `canExec` call outside of the `transact` call"
      );
    const t = this.prosemirrorState, o = this.prosemirrorView;
    return e(t, void 0, o);
  }
  /**
   * Execute a function within a "blocknote transaction".
   * All changes to the editor within the transaction will be grouped together, so that
   * we can dispatch them as a single operation (thus creating only a single undo step)
   *
   * @note There is no need to dispatch the transaction, as it will be automatically dispatched when the callback is complete.
   *
   * @example
   * ```ts
   * // All changes to the editor will be grouped together
   * editor.transact((tr) => {
   *   tr.insertText("Hello, world!");
   * // These two operations will be grouped together in a single undo step
   *   editor.transact((tr) => {
   *     tr.insertText("Hello, world!");
   *   });
   * });
   * ```
   */
  transact(e) {
    if (this.activeTransaction)
      return e(this.activeTransaction);
    try {
      this.activeTransaction = this.editor._tiptapEditor.state.tr;
      const t = e(this.activeTransaction), o = this.activeTransaction;
      return this.activeTransaction = null, o && // Only dispatch if the transaction was actually modified in some way
      (o.docChanged || o.selectionSet || o.scrolledIntoView || o.storedMarksSet || !o.isGeneric) && this.prosemirrorView.dispatch(o), t;
    } finally {
      this.activeTransaction = null;
    }
  }
  /**
   * Get the underlying prosemirror state
   * @note Prefer using `editor.transact` to read the current editor state, as that will ensure the state is up to date
   * @see https://prosemirror.net/docs/ref/#state.EditorState
   */
  get prosemirrorState() {
    if (this.activeTransaction)
      throw new Error(
        "`prosemirrorState` should not be called within a `transact` call, move the `prosemirrorState` call outside of the `transact` call or use `editor.transact` to read the current editor state"
      );
    return this.editor._tiptapEditor.state;
  }
  /**
   * Get the underlying prosemirror view
   * @see https://prosemirror.net/docs/ref/#view.EditorView
   */
  get prosemirrorView() {
    return this.editor._tiptapEditor.view;
  }
  isFocused() {
    var e;
    return ((e = this.prosemirrorView) == null ? void 0 : e.hasFocus()) || !1;
  }
  focus() {
    var e;
    (e = this.prosemirrorView) == null || e.focus();
  }
  /**
   * Checks if the editor is currently editable, or if it's locked.
   * @returns True if the editor is editable, false otherwise.
   */
  get isEditable() {
    if (!this.editor._tiptapEditor) {
      if (!this.editor.headless)
        throw new Error("no editor, but also not headless?");
      return !1;
    }
    return this.editor._tiptapEditor.isEditable === void 0 ? !0 : this.editor._tiptapEditor.isEditable;
  }
  /**
   * Makes the editor editable or locks it, depending on the argument passed.
   * @param editable True to make the editor editable, or false to lock it.
   */
  set isEditable(e) {
    if (!this.editor._tiptapEditor) {
      if (!this.editor.headless)
        throw new Error("no editor, but also not headless?");
      return;
    }
    this.editor._tiptapEditor.options.editable !== e && this.editor._tiptapEditor.setEditable(e);
  }
  /**
   * Undo the last action.
   */
  undo() {
    const e = this.editor.getExtension("yUndo");
    if (e)
      return this.exec(e.undoCommand);
    const t = this.editor.getExtension("history");
    if (t)
      return this.exec(t.undoCommand);
    throw new Error("No undo plugin found");
  }
  /**
   * Redo the last action.
   */
  redo() {
    const e = this.editor.getExtension("yUndo");
    if (e)
      return this.exec(e.redoCommand);
    const t = this.editor.getExtension("history");
    if (t)
      return this.exec(t.redoCommand);
    throw new Error("No redo plugin found");
  }
}
function gn(n, e, t, o = { updateSelection: !0 }) {
  let { from: s, to: a } = typeof e == "number" ? { from: e, to: e } : { from: e.from, to: e.to }, r = !0, c = !0, i = "";
  if (t.forEach((l) => {
    l.check(), r && l.isText && l.marks.length === 0 ? i += l.text : r = !1, c = c ? l.isBlock : !1;
  }), s === a && c) {
    const { parent: l } = n.doc.resolve(s);
    l.isTextblock && !l.type.spec.code && !l.childCount && (s -= 1, a += 1);
  }
  return r ? n.insertText(i, s, a) : n.replaceWith(s, a, t), o.updateSelection && vt(n, n.steps.length - 1, -1), !0;
}
class bn {
  constructor(e) {
    this.editor = e;
  }
  /**
   * Insert a piece of content at the current cursor position.
   *
   * @param content can be a string, or array of partial inline content elements
   */
  insertInlineContent(e, { updateSelection: t = !1 } = {}) {
    const o = be(
      e,
      this.editor.schema.inlineContentSchema
    ), s = q(o, this.editor.pmSchema);
    this.editor.transact((a) => {
      gn(
        a,
        {
          from: a.selection.from,
          to: a.selection.to
        },
        s,
        {
          updateSelection: t
        }
      );
    });
  }
  /**
   * Gets the active text styles at the text cursor position or at the end of the current selection if it's active.
   */
  getActiveStyles() {
    return this.editor.transact((e) => {
      const t = {}, o = e.selection.$to.marks();
      for (const s of o) {
        const a = this.editor.schema.styleSchema[s.type.name];
        if (!a) {
          // Links are not considered styles in blocknote
          s.type.name !== "link" && // "blocknoteIgnore" tagged marks (such as comments) are also not considered BlockNote "styles"
          !s.type.spec.blocknoteIgnore && console.warn("mark not found in styleschema", s.type.name);
          continue;
        }
        a.propSchema === "boolean" ? t[a.type] = !0 : t[a.type] = s.attrs.stringValue;
      }
      return t;
    });
  }
  /**
   * Adds styles to the currently selected content.
   * @param styles The styles to add.
   */
  addStyles(e) {
    for (const [t, o] of Object.entries(e)) {
      const s = this.editor.schema.styleSchema[t];
      if (!s)
        throw new Error(`style ${t} not found in styleSchema`);
      if (s.propSchema === "boolean")
        this.editor._tiptapEditor.commands.setMark(t);
      else if (s.propSchema === "string")
        this.editor._tiptapEditor.commands.setMark(t, {
          stringValue: o
        });
      else
        throw new O(s.propSchema);
    }
  }
  /**
   * Removes styles from the currently selected content.
   * @param styles The styles to remove.
   */
  removeStyles(e) {
    for (const t of Object.keys(e))
      this.editor._tiptapEditor.commands.unsetMark(t);
  }
  /**
   * Toggles styles on the currently selected content.
   * @param styles The styles to toggle.
   */
  toggleStyles(e) {
    for (const [t, o] of Object.entries(e)) {
      const s = this.editor.schema.styleSchema[t];
      if (!s)
        throw new Error(`style ${t} not found in styleSchema`);
      if (s.propSchema === "boolean")
        this.editor._tiptapEditor.commands.toggleMark(t);
      else if (s.propSchema === "string")
        this.editor._tiptapEditor.commands.toggleMark(t, {
          stringValue: o
        });
      else
        throw new O(s.propSchema);
    }
  }
  /**
   * Gets the currently selected text.
   */
  getSelectedText() {
    return this.editor.transact((e) => e.doc.textBetween(e.selection.from, e.selection.to));
  }
  /**
   * Gets the URL of the last link in the current selection, or `undefined` if there are no links in the selection.
   */
  getSelectedLinkUrl() {
    return this.editor._tiptapEditor.getAttributes("link").href;
  }
  /**
   * Creates a new link to replace the selected content.
   * @param url The link URL.
   * @param text The text to display the link with.
   */
  createLink(e, t) {
    if (e === "")
      return;
    const o = this.editor.pmSchema.mark("link", { href: e });
    this.editor.transact((s) => {
      const { from: a, to: r } = s.selection;
      t ? s.insertText(t, a, r).addMark(a, a + t.length, o) : s.setSelection(Kt.create(s.doc, r)).addMark(
        a,
        r,
        o
      );
    });
  }
}
function yn(n, e) {
  const t = [];
  return n.forEach((o, s, a) => {
    a !== e && t.push(o);
  }), te.from(t);
}
function Sn(n, e) {
  const t = [];
  for (let o = 0; o < n.childCount; o++)
    if (n.child(o).type.name === "tableRow")
      if (t.length > 0 && t[t.length - 1].type.name === "table") {
        const s = t[t.length - 1], a = s.copy(s.content.addToEnd(n.child(o)));
        t[t.length - 1] = a;
      } else {
        const s = e.nodes.table.createChecked(
          void 0,
          n.child(o)
        );
        t.push(s);
      }
    else
      t.push(n.child(o));
  return n = te.from(t), n;
}
function Bn(n, e) {
  let t = te.from(n.content);
  if (t = Sn(t, e.state.schema), !Cn(t, e))
    return new re(t, n.openStart, n.openEnd);
  for (let o = 0; o < t.childCount; o++)
    if (t.child(o).type.spec.group === "blockContent") {
      const s = [t.child(o)];
      if (o + 1 < t.childCount && t.child(o + 1).type.name === "blockGroup") {
        const r = t.child(o + 1).child(0).child(0);
        (r.type.name === "bulletListItem" || r.type.name === "numberedListItem" || r.type.name === "checkListItem") && (s.push(t.child(o + 1)), t = yn(t, o + 1));
      }
      const a = e.state.schema.nodes.blockContainer.createChecked(
        void 0,
        s
      );
      t = t.replaceChild(o, a);
    }
  return new re(t, n.openStart, n.openEnd);
}
function Cn(n, e) {
  var a, r;
  const t = n.childCount === 1, o = ((a = n.firstChild) == null ? void 0 : a.type.spec.content) === "inline*", s = ((r = n.firstChild) == null ? void 0 : r.type.spec.content) === "tableRow+";
  if (t) {
    if (o)
      return !1;
    if (s) {
      const c = y(e.state);
      if (c.isBlockContainer)
        return !(c.blockContent.node.type.spec.content === "tableRow+");
    }
  }
  return !0;
}
const En = {
  enableInputRules: !0,
  enablePasteRules: !0,
  enableCoreExtensions: !1
};
class Ne extends Be {
  constructor(t) {
    var l, d, u, p, h, f, k, g, B, w;
    super();
    /**
     * The underlying prosemirror schema
     */
    m(this, "pmSchema");
    m(this, "_tiptapEditor");
    /**
     * Used by React to store a reference to an `ElementRenderer` helper utility to make sure we can render React elements
     * in the correct context (used by `ReactRenderUtil`)
     */
    m(this, "elementRenderer", null);
    /**
     * Cache of all blocks. This makes sure we don't have to "recompute" blocks if underlying Prosemirror Nodes haven't changed.
     * This is especially useful when we want to keep track of the same block across multiple operations,
     * with this cache, blocks stay the same object reference (referential equality with ===).
     */
    m(this, "blockCache", /* @__PURE__ */ new WeakMap());
    /**
     * The dictionary contains translations for the editor.
     */
    m(this, "dictionary");
    /**
     * The schema of the editor. The schema defines which Blocks, InlineContent, and Styles are available in the editor.
     */
    m(this, "schema");
    m(this, "blockImplementations");
    m(this, "inlineContentImplementations");
    m(this, "styleImplementations");
    /**
     * The `uploadFile` method is what the editor uses when files need to be uploaded (for example when selecting an image to upload).
     * This method should set when creating the editor as this is application-specific.
     *
     * `undefined` means the application doesn't support file uploads.
     *
     * @param file The file that should be uploaded.
     * @returns The URL of the uploaded file OR an object containing props that should be set on the file block (such as an id)
     */
    m(this, "uploadFile");
    m(this, "onUploadStartCallbacks", []);
    m(this, "onUploadEndCallbacks", []);
    m(this, "resolveFileUrl");
    /**
     * Editor settings
     */
    m(this, "settings");
    // Manager instances
    m(this, "_blockManager");
    m(this, "_eventManager");
    m(this, "_exportManager");
    m(this, "_extensionManager");
    m(this, "_selectionManager");
    m(this, "_stateManager");
    m(this, "_styleManager");
    /**
     * Remove extension(s) from the editor
     */
    m(this, "unregisterExtension", (...t) => this._extensionManager.unregisterExtension(...t));
    /**
     * Register extension(s) to the editor
     */
    m(this, "registerExtension", (...t) => this._extensionManager.registerExtension(...t));
    /**
     * Get an extension from the editor
     */
    m(this, "getExtension", (...t) => this._extensionManager.getExtension(...t));
    /**
     * Mount the editor to a DOM element.
     *
     * @warning Not needed to call manually when using React, use BlockNoteView to take care of mounting
     */
    m(this, "mount", (t) => {
      this._tiptapEditor.mount({ mount: t });
    });
    /**
     * Unmount the editor from the DOM element it is bound to
     */
    m(this, "unmount", () => {
      this._tiptapEditor.unmount();
    });
    this.options = t, this.dictionary = t.dictionary || Dt, this.settings = {
      tables: {
        splitCells: ((l = t == null ? void 0 : t.tables) == null ? void 0 : l.splitCells) ?? !1,
        cellBackgroundColor: ((d = t == null ? void 0 : t.tables) == null ? void 0 : d.cellBackgroundColor) ?? !1,
        cellTextColor: ((u = t == null ? void 0 : t.tables) == null ? void 0 : u.cellTextColor) ?? !1,
        headers: ((p = t == null ? void 0 : t.tables) == null ? void 0 : p.headers) ?? !1
      }
    };
    const o = {
      defaultStyles: !0,
      schema: t.schema || Mt.create(),
      ...t,
      placeholders: {
        ...this.dictionary.placeholders,
        ...t.placeholders
      }
    };
    if (this.schema = o.schema, this.blockImplementations = o.schema.blockSpecs, this.inlineContentImplementations = o.schema.inlineContentSpecs, this.styleImplementations = o.schema.styleSpecs, o.uploadFile) {
      const C = o.uploadFile;
      this.uploadFile = async (P, T) => {
        this.onUploadStartCallbacks.forEach(
          (v) => v.apply(this, [T])
        );
        try {
          return await C(P, T);
        } finally {
          this.onUploadEndCallbacks.forEach(
            (v) => v.apply(this, [T])
          );
        }
      };
    }
    this.resolveFileUrl = o.resolveFileUrl, this._eventManager = new xo(this), this._extensionManager = new dn(this, o);
    const s = this._extensionManager.getTiptapExtensions(), a = this._extensionManager.hasExtension("ySync") || this._extensionManager.hasExtension("liveblocksExtension");
    a && o.initialContent && console.warn(
      "When using Collaboration, initialContent might cause conflicts, because changes should come from the collaboration provider"
    );
    const r = {
      ...En,
      ...o._tiptapOptions,
      element: null,
      autofocus: o.autofocus ?? !1,
      extensions: s,
      editorProps: {
        ...(h = o._tiptapOptions) == null ? void 0 : h.editorProps,
        attributes: {
          // As of TipTap v2.5.0 the tabIndex is removed when the editor is not
          // editable, so you can't focus it. We want to revert this as we have
          // UI behaviour that relies on it.
          tabIndex: "0",
          ...(k = (f = o._tiptapOptions) == null ? void 0 : f.editorProps) == null ? void 0 : k.attributes,
          ...(g = o.domAttributes) == null ? void 0 : g.editor,
          class: X(
            "bn-editor",
            o.defaultStyles ? "bn-default-styles" : "",
            ((w = (B = o.domAttributes) == null ? void 0 : B.editor) == null ? void 0 : w.class) || ""
          )
        },
        transformPasted: Bn
      }
    };
    try {
      const C = o.initialContent || (a ? [
        {
          type: "paragraph",
          id: "initialBlockId"
        }
      ] : [
        {
          type: "paragraph",
          id: ge.options.generateID()
        }
      ]);
      if (!Array.isArray(C) || C.length === 0)
        throw new Error(
          "initialContent must be a non-empty array of blocks, received: " + C
        );
      const P = It(r.extensions), T = C.map(
        (Oe) => Z(
          Q(this.schema, Oe),
          P,
          this.schema.styleSchema
        ).toJSON()
      ), v = At(
        {
          type: "doc",
          content: [
            {
              type: "blockGroup",
              content: T
            }
          ]
        },
        P,
        r.parseOptions
      );
      this._tiptapEditor = new _t({
        ...r,
        content: v.toJSON()
      }), this.pmSchema = this._tiptapEditor.schema;
    } catch (C) {
      throw new Error(
        "Error creating document from blocks passed as `initialContent`",
        { cause: C }
      );
    }
    let c;
    const i = this.pmSchema.nodes.doc.createAndFill;
    this.pmSchema.nodes.doc.createAndFill = (...C) => {
      if (c)
        return c;
      const P = i.apply(this.pmSchema.nodes.doc, C), T = JSON.parse(JSON.stringify(P.toJSON()));
      return T.content[0].content[0].attrs.id = "initialBlockId", c = Ve.fromJSON(this.pmSchema, T), c;
    }, this.pmSchema.cached.blockNoteEditor = this, this._blockManager = new Eo(this), this._exportManager = new Lo(this), this._selectionManager = new mn(this), this._stateManager = new kn(this), this._styleManager = new bn(this), this.emit("create");
  }
  static create(t) {
    return new Ne(t ?? {});
  }
  /**
   * BlockNote extensions that are added to the editor, keyed by the extension key
   */
  get extensions() {
    return this._extensionManager.getExtensions();
  }
  /**
   * Execute a prosemirror command. This is mostly for backwards compatibility with older code.
   *
   * @note You should prefer the {@link transact} method when possible, as it will automatically handle the dispatching of the transaction and work across blocknote transactions.
   *
   * @example
   * ```ts
   * editor.exec((state, dispatch, view) => {
   *   dispatch(state.tr.insertText("Hello, world!"));
   * });
   * ```
   */
  exec(t) {
    return this._stateManager.exec(t);
  }
  /**
   * Check if a command can be executed. A command should return `false` if it is not valid in the current state.
   *
   * @example
   * ```ts
   * if (editor.canExec(command)) {
   *   // show button
   * } else {
   *   // hide button
   * }
   * ```
   */
  canExec(t) {
    return this._stateManager.canExec(t);
  }
  /**
   * Execute a function within a "blocknote transaction".
   * All changes to the editor within the transaction will be grouped together, so that
   * we can dispatch them as a single operation (thus creating only a single undo step)
   *
   * @note There is no need to dispatch the transaction, as it will be automatically dispatched when the callback is complete.
   *
   * @example
   * ```ts
   * // All changes to the editor will be grouped together
   * editor.transact((tr) => {
   *   tr.insertText("Hello, world!");
   * // These two operations will be grouped together in a single undo step
   *   editor.transact((tr) => {
   *     tr.insertText("Hello, world!");
   *   });
   * });
   * ```
   */
  transact(t) {
    return this._stateManager.transact(t);
  }
  /**
   * Get the underlying prosemirror state
   * @note Prefer using `editor.transact` to read the current editor state, as that will ensure the state is up to date
   * @see https://prosemirror.net/docs/ref/#state.EditorState
   */
  get prosemirrorState() {
    return this._stateManager.prosemirrorState;
  }
  /**
   * Get the underlying prosemirror view
   * @see https://prosemirror.net/docs/ref/#view.EditorView
   */
  get prosemirrorView() {
    return this._stateManager.prosemirrorView;
  }
  get domElement() {
    var t;
    if (!this.headless)
      return (t = this.prosemirrorView) == null ? void 0 : t.dom;
  }
  isFocused() {
    var t;
    return this.headless ? !1 : ((t = this.prosemirrorView) == null ? void 0 : t.hasFocus()) || !1;
  }
  get headless() {
    return !this._tiptapEditor.isInitialized;
  }
  /**
   * Focus on the editor
   */
  focus() {
    this.headless || this.prosemirrorView.focus();
  }
  /**
   * Blur the editor
   */
  blur() {
    this.headless || this.prosemirrorView.dom.blur();
  }
  // TODO move to extension
  onUploadStart(t) {
    return this.onUploadStartCallbacks.push(t), () => {
      const o = this.onUploadStartCallbacks.indexOf(t);
      o > -1 && this.onUploadStartCallbacks.splice(o, 1);
    };
  }
  onUploadEnd(t) {
    return this.onUploadEndCallbacks.push(t), () => {
      const o = this.onUploadEndCallbacks.indexOf(t);
      o > -1 && this.onUploadEndCallbacks.splice(o, 1);
    };
  }
  /**
   * @deprecated, use `editor.document` instead
   */
  get topLevelBlocks() {
    return this.document;
  }
  /**
   * Gets a snapshot of all top-level (non-nested) blocks in the editor.
   * @returns A snapshot of all top-level (non-nested) blocks in the editor.
   */
  get document() {
    return this._blockManager.document;
  }
  /**
   * Gets a snapshot of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block that should be
   * retrieved.
   * @returns The block that matches the identifier, or `undefined` if no
   * matching block was found.
   */
  getBlock(t) {
    return this._blockManager.getBlock(t);
  }
  /**
   * Gets a snapshot of the previous sibling of an existing block from the
   * editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * previous sibling should be retrieved.
   * @returns The previous sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the first child/block
   * in the document.
   */
  getPrevBlock(t) {
    return this._blockManager.getPrevBlock(t);
  }
  /**
   * Gets a snapshot of the next sibling of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * next sibling should be retrieved.
   * @returns The next sibling of the block that matches the identifier.
   * `undefined` if no matching block was found, or it's the last child/block in
   * the document.
   */
  getNextBlock(t) {
    return this._blockManager.getNextBlock(t);
  }
  /**
   * Gets a snapshot of the parent of an existing block from the editor.
   * @param blockIdentifier The identifier of an existing block for which the
   * parent should be retrieved.
   * @returns The parent of the block that matches the identifier. `undefined`
   * if no matching block was found, or the block isn't nested.
   */
  getParentBlock(t) {
    return this._blockManager.getParentBlock(t);
  }
  /**
   * Traverses all blocks in the editor depth-first, and executes a callback for each.
   * @param callback The callback to execute for each block. Returning `false` stops the traversal.
   * @param reverse Whether the blocks should be traversed in reverse order.
   */
  forEachBlock(t, o = !1) {
    this._blockManager.forEachBlock(t, o);
  }
  /**
   * Executes a callback whenever the editor's contents change.
   * @param callback The callback to execute.
   *
   * @deprecated use {@link BlockNoteEditor.onChange} instead
   */
  onEditorContentChange(t) {
    this._tiptapEditor.on("update", t);
  }
  /**
   * Executes a callback whenever the editor's selection changes.
   * @param callback The callback to execute.
   *
   * @deprecated use `onSelectionChange` instead
   */
  onEditorSelectionChange(t) {
    this._tiptapEditor.on("selectionUpdate", t);
  }
  /**
   * Gets a snapshot of the current text cursor position.
   * @returns A snapshot of the current text cursor position.
   */
  getTextCursorPosition() {
    return this._selectionManager.getTextCursorPosition();
  }
  /**
   * Sets the text cursor position to the start or end of an existing block. Throws an error if the target block could
   * not be found.
   * @param targetBlock The identifier of an existing block that the text cursor should be moved to.
   * @param placement Whether the text cursor should be placed at the start or end of the block.
   */
  setTextCursorPosition(t, o = "start") {
    return this._selectionManager.setTextCursorPosition(t, o);
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned data will contain the entire block.
   */
  getSelection() {
    return this._selectionManager.getSelection();
  }
  /**
   * Gets a snapshot of the current selection. This contains all blocks (included nested blocks)
   * that the selection spans across.
   *
   * If the selection starts / ends halfway through a block, the returned block will be
   * only the part of the block that is included in the selection.
   */
  getSelectionCutBlocks() {
    return this._selectionManager.getSelectionCutBlocks();
  }
  /**
   * Sets the selection to a range of blocks.
   * @param startBlock The identifier of the block that should be the start of the selection.
   * @param endBlock The identifier of the block that should be the end of the selection.
   */
  setSelection(t, o) {
    return this._selectionManager.setSelection(t, o);
  }
  /**
   * Checks if the editor is currently editable, or if it's locked.
   * @returns True if the editor is editable, false otherwise.
   */
  get isEditable() {
    return this._stateManager.isEditable;
  }
  /**
   * Makes the editor editable or locks it, depending on the argument passed.
   * @param editable True to make the editor editable, or false to lock it.
   */
  set isEditable(t) {
    this._stateManager.isEditable = t;
  }
  /**
   * Inserts new blocks into the editor. If a block's `id` is undefined, BlockNote generates one automatically. Throws an
   * error if the reference block could not be found.
   * @param blocksToInsert An array of partial blocks that should be inserted.
   * @param referenceBlock An identifier for an existing block, at which the new blocks should be inserted.
   * @param placement Whether the blocks should be inserted just before, just after, or nested inside the
   * `referenceBlock`.
   */
  insertBlocks(t, o, s = "before") {
    return this._blockManager.insertBlocks(
      t,
      o,
      s
    );
  }
  /**
   * Updates an existing block in the editor. Since updatedBlock is a PartialBlock object, some fields might not be
   * defined. These undefined fields are kept as-is from the existing block. Throws an error if the block to update could
   * not be found.
   * @param blockToUpdate The block that should be updated.
   * @param update A partial block which defines how the existing block should be changed.
   */
  updateBlock(t, o) {
    return this._blockManager.updateBlock(t, o);
  }
  /**
   * Removes existing blocks from the editor. Throws an error if any of the blocks could not be found.
   * @param blocksToRemove An array of identifiers for existing blocks that should be removed.
   */
  removeBlocks(t) {
    return this._blockManager.removeBlocks(t);
  }
  /**
   * Replaces existing blocks in the editor with new blocks. If the blocks that should be removed are not adjacent or
   * are at different nesting levels, `blocksToInsert` will be inserted at the position of the first block in
   * `blocksToRemove`. Throws an error if any of the blocks to remove could not be found.
   * @param blocksToRemove An array of blocks that should be replaced.
   * @param blocksToInsert An array of partial blocks to replace the old ones with.
   */
  replaceBlocks(t, o) {
    return this._blockManager.replaceBlocks(t, o);
  }
  /**
   * Undo the last action.
   */
  undo() {
    return this._stateManager.undo();
  }
  /**
   * Redo the last action.
   */
  redo() {
    return this._stateManager.redo();
  }
  /**
   * Insert a piece of content at the current cursor position.
   *
   * @param content can be a string, or array of partial inline content elements
   */
  insertInlineContent(t, { updateSelection: o = !1 } = {}) {
    this._styleManager.insertInlineContent(t, { updateSelection: o });
  }
  /**
   * Gets the active text styles at the text cursor position or at the end of the current selection if it's active.
   */
  getActiveStyles() {
    return this._styleManager.getActiveStyles();
  }
  /**
   * Adds styles to the currently selected content.
   * @param styles The styles to add.
   */
  addStyles(t) {
    this._styleManager.addStyles(t);
  }
  /**
   * Removes styles from the currently selected content.
   * @param styles The styles to remove.
   */
  removeStyles(t) {
    this._styleManager.removeStyles(t);
  }
  /**
   * Toggles styles on the currently selected content.
   * @param styles The styles to toggle.
   */
  toggleStyles(t) {
    this._styleManager.toggleStyles(t);
  }
  /**
   * Gets the currently selected text.
   */
  getSelectedText() {
    return this._styleManager.getSelectedText();
  }
  /**
   * Gets the URL of the last link in the current selection, or `undefined` if there are no links in the selection.
   */
  getSelectedLinkUrl() {
    return this._styleManager.getSelectedLinkUrl();
  }
  /**
   * Creates a new link to replace the selected content.
   * @param url The link URL.
   * @param text The text to display the link with.
   */
  createLink(t, o) {
    this._styleManager.createLink(t, o);
  }
  /**
   * Checks if the block containing the text cursor can be nested.
   */
  canNestBlock() {
    return this._blockManager.canNestBlock();
  }
  /**
   * Nests the block containing the text cursor into the block above it.
   */
  nestBlock() {
    this._blockManager.nestBlock();
  }
  /**
   * Checks if the block containing the text cursor is nested.
   */
  canUnnestBlock() {
    return this._blockManager.canUnnestBlock();
  }
  /**
   * Lifts the block containing the text cursor out of its parent.
   */
  unnestBlock() {
    this._blockManager.unnestBlock();
  }
  /**
   * Moves the selected blocks up. If the previous block has children, moves
   * them to the end of its children. If there is no previous block, but the
   * current blocks share a common parent, moves them out of & before it.
   */
  moveBlocksUp() {
    return this._blockManager.moveBlocksUp();
  }
  /**
   * Moves the selected blocks down. If the next block has children, moves
   * them to the start of its children. If there is no next block, but the
   * current blocks share a common parent, moves them out of & after it.
   */
  moveBlocksDown() {
    return this._blockManager.moveBlocksDown();
  }
  /**
   * Exports blocks into a simplified HTML string. To better conform to HTML standards, children of blocks which aren't list
   * items are un-nested in the output HTML.
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToHTMLLossy(t = this.document) {
    return this._exportManager.blocksToHTMLLossy(t);
  }
  /**
   * Serializes blocks into an HTML string in the format that would normally be rendered by the editor.
   *
   * Use this method if you want to server-side render HTML (for example, a blog post that has been edited in BlockNote)
   * and serve it to users without loading the editor on the client (i.e.: displaying the blog post)
   *
   * @param blocks An array of blocks that should be serialized into HTML.
   * @returns The blocks, serialized as an HTML string.
   */
  blocksToFullHTML(t = this.document) {
    return this._exportManager.blocksToFullHTML(t);
  }
  /**
   * Parses blocks from an HTML string. Tries to create `Block` objects out of any HTML block-level elements, and
   * `InlineNode` objects from any HTML inline elements, though not all element types are recognized. If BlockNote
   * doesn't recognize an HTML element's tag, it will parse it as a paragraph or plain text.
   * @param html The HTML string to parse blocks from.
   * @returns The blocks parsed from the HTML string.
   */
  tryParseHTMLToBlocks(t) {
    return this._exportManager.tryParseHTMLToBlocks(t);
  }
  /**
   * Serializes blocks into a Markdown string. The output is simplified as Markdown does not support all features of
   * BlockNote - children of blocks which aren't list items are un-nested and certain styles are removed.
   * @param blocks An array of blocks that should be serialized into Markdown.
   * @returns The blocks, serialized as a Markdown string.
   */
  blocksToMarkdownLossy(t = this.document) {
    return this._exportManager.blocksToMarkdownLossy(t);
  }
  /**
   * Creates a list of blocks from a Markdown string. Tries to create `Block` and `InlineNode` objects based on
   * Markdown syntax, though not all symbols are recognized. If BlockNote doesn't recognize a symbol, it will parse it
   * as text.
   * @param markdown The Markdown string to parse blocks from.
   * @returns The blocks parsed from the Markdown string.
   */
  tryParseMarkdownToBlocks(t) {
    return this._exportManager.tryParseMarkdownToBlocks(t);
  }
  /**
   * A callback function that runs whenever the editor's contents change.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onChange(t, o) {
    return this._eventManager.onChange(t, o);
  }
  /**
   * A callback function that runs whenever the text cursor position or selection changes.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onSelectionChange(t, o) {
    return this._eventManager.onSelectionChange(
      t,
      o
    );
  }
  /**
   * A callback function that runs when the editor has been mounted.
   *
   * This can be useful for plugins to initialize themselves after the editor has been mounted.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onMount(t) {
    this._eventManager.onMount(t);
  }
  /**
   * A callback function that runs when the editor has been unmounted.
   *
   * This can be useful for plugins to clean up themselves after the editor has been unmounted.
   *
   * @param callback The callback to execute.
   * @returns A function to remove the callback.
   */
  onUnmount(t) {
    this._eventManager.onUnmount(t);
  }
  /**
   * Gets the bounding box of the current selection.
   * @returns The bounding box of the current selection.
   */
  getSelectionBoundingBox() {
    return this._selectionManager.getSelectionBoundingBox();
  }
  get isEmpty() {
    const t = this.document;
    return t.length === 0 || t.length === 1 && t[0].type === "paragraph" && t[0].content.length === 0;
  }
  /**
   * Paste HTML into the editor. Defaults to converting HTML to BlockNote HTML.
   * @param html The HTML to paste.
   * @param raw Whether to paste the HTML as is, or to convert it to BlockNote HTML.
   */
  pasteHTML(t, o = !1) {
    this._exportManager.pasteHTML(t, o);
  }
  /**
   * Paste text into the editor. Defaults to interpreting text as markdown.
   * @param text The text to paste.
   */
  pasteText(t) {
    return this._exportManager.pasteText(t);
  }
  /**
   * Paste markdown into the editor.
   * @param markdown The markdown to paste.
   */
  pasteMarkdown(t) {
    return this._exportManager.pasteMarkdown(t);
  }
}
class Zn {
  constructor(e, t, o) {
    this.mappings = t, this.options = o;
  }
  async resolveFile(e) {
    var o;
    if (!((o = this.options) != null && o.resolveFileUrl))
      return (await fetch(e)).blob();
    const t = await this.options.resolveFileUrl(e);
    return t instanceof Blob ? t : (await fetch(t)).blob();
  }
  mapStyles(e) {
    return Object.entries(e).map(([o, s]) => this.mappings.styleMapping[o](s, this));
  }
  mapInlineContent(e) {
    return this.mappings.inlineContentMapping[e.type](
      e,
      this
    );
  }
  transformInlineContent(e) {
    return e.map((t) => this.mapInlineContent(t));
  }
  async mapBlock(e, t, o, s) {
    return this.mappings.blockMapping[e.type](
      e,
      this,
      t,
      o,
      s
    );
  }
}
function Qn(n) {
  return {
    createBlockMapping: (e) => e,
    createInlineContentMapping: (e) => e,
    createStyleMapping: (e) => e
  };
}
function Xn(n, ...e) {
  const t = [...n];
  for (const o of e)
    for (const s of o) {
      const a = t.findLastIndex(
        (r) => r.group === s.group
      );
      a === -1 ? t.push(s) : t.splice(a + 1, 0, s);
    }
  return t;
}
export {
  Ne as BlockNoteEditor,
  Mt as BlockNoteSchema,
  gs as COLORS_DARK_MODE_DEFAULT,
  bs as COLORS_DEFAULT,
  aa as CustomBlockNoteSchema,
  ys as EMPTY_CELL_HEIGHT,
  Ss as EMPTY_CELL_WIDTH,
  Be as EventEmitter,
  Zn as Exporter,
  Bs as FILE_AUDIO_ICON_SVG,
  Cs as FILE_IMAGE_ICON_SVG,
  Es as FILE_VIDEO_ICON_SVG,
  Ie as HTMLToBlocks,
  ge as UniqueID,
  O as UnreachableCaseError,
  xs as addDefaultPropsExternalHTML,
  $ as addInlineContentAttributes,
  Ze as addInlineContentKeyboardShortcuts,
  Ms as addNodeAndExtensionsToSpec,
  Ts as addStyleAttributes,
  ws as applyNonSelectableBlockFix,
  os as assertEmpty,
  Ps as audioParse,
  vs as audioRender,
  Is as audioToExternalHTML,
  As as baseFileZodPropSchema,
  _s as blockHasZodProps,
  Z as blockToNode,
  st as blocksToMarkdown,
  Ds as camelToDataKebab,
  Ls as captureCellAnchor,
  ia as checkPageBreakBlocksInSchema,
  rt as cleanHTMLToMarkdown,
  Xn as combineByGroup,
  je as contentNodeToInlineContent,
  Re as contentNodeToTableContent,
  Ns as createAudioBlockConfig,
  Os as createAudioBlockSpec,
  Fs as createBlockConfig,
  Hs as createBlockSpec,
  $s as createBlockSpecFromTiptapNode,
  Vs as createBulletListItemBlockConfig,
  Us as createBulletListItemBlockSpec,
  zs as createCheckListItemBlockSpec,
  Gs as createCheckListItemConfig,
  Rs as createCodeBlockConfig,
  js as createCodeBlockSpec,
  Ws as createDefaultBlockDOMOutputSpec,
  Ks as createDividerBlockConfig,
  Js as createDividerBlockSpec,
  ha as createExtension,
  Se as createExternalHTMLExporter,
  Ys as createFileBlockConfig,
  qs as createFileBlockSpec,
  Zs as createHeadingBlockConfig,
  Qs as createHeadingBlockSpec,
  Xs as createImageBlockConfig,
  er as createImageBlockSpec,
  qn as createInlineContentSpec,
  Xe as createInlineContentSpecFromTipTapNode,
  ho as createInternalHTMLSerializer,
  tr as createInternalInlineContentSpec,
  or as createInternalStyleSpec,
  nr as createNumberedListItemBlockConfig,
  sr as createNumberedListItemBlockSpec,
  ca as createPageBreakBlockConfig,
  la as createPageBreakBlockSpec,
  rr as createParagraphBlockConfig,
  ar as createParagraphBlockSpec,
  ir as createPropSchemaFromZod,
  cr as createQuoteBlockConfig,
  lr as createQuoteBlockSpec,
  ma as createStore,
  dr as createStyleSpec,
  ur as createStyleSpecFromTipTapMark,
  pr as createTableBlockSpec,
  fr as createToggleListItemBlockConfig,
  hr as createToggleListItemBlockSpec,
  mr as createToggleWrapper,
  kr as createVideoBlockConfig,
  gr as createVideoBlockSpec,
  br as defaultBlockSpecs,
  yr as defaultBlockToHTML,
  Sr as defaultInlineContentSchema,
  Br as defaultInlineContentSpecs,
  Cr as defaultPropSchema,
  Er as defaultStyleSchema,
  xr as defaultStyleSpecs,
  Mr as defaultToggledState,
  Tr as defaultZodPropSchema,
  Ge as docToBlocks,
  wr as editorHasBlockType,
  Pr as editorHasBlockTypeAndPropsAreValid,
  vr as editorHasBlockTypeAndZodProps,
  Ir as fileParse,
  Ar as filenameFromURL,
  K as fixColumnList,
  _r as formatKeyboardShortcut,
  Ke as getBackgroundColorAttribute,
  yo as getBlock,
  ns as getBlockCache,
  Dr as getBlockFromPos,
  z as getBlockInfo,
  Y as getBlockInfoFromResolvedPos,
  y as getBlockInfoFromSelection,
  F as getBlockInfoFromTransaction,
  ss as getBlockInfoWithManualOffset,
  H as getBlockNoteSchema,
  rs as getBlockSchema,
  nt as getBlocksChangedByTransaction,
  as as getColspan,
  lo as getInlineContentParseRules,
  is as getInlineContentSchema,
  Lr as getInlineContentSchemaFromSpecs,
  Nr as getLanguageId,
  _ as getNearestBlockPos,
  Bo as getNextBlock,
  E as getNodeById,
  da as getPageBreakSlashMenuItems,
  Co as getParentBlock,
  Or as getParseRules,
  S as getPmSchema,
  So as getPrevBlock,
  cs as getRowspan,
  Fr as getStyleParseRules,
  ls as getStyleSchema,
  Hr as getStyleSchemaFromSpecs,
  $r as getTextAlignmentAttribute,
  qe as getTextColorAttribute,
  Vr as imageParse,
  Ur as imageRender,
  zr as imageToExternalHTML,
  q as inlineContentToNodes,
  uo as insertBlocks,
  Gr as isAppleOS,
  W as isEmptyColumn,
  Rr as isFileBlock,
  ds as isLinkInlineContent,
  jr as isNodeBlock,
  us as isPartialLinkInlineContent,
  ps as isPartialTableCell,
  Wr as isSafari,
  fs as isStyledTextInlineContent,
  hs as isTableCell,
  Kr as isTableCellSelection,
  tt as isVideoUrl,
  ms as mapTableCell,
  Qn as mappingFactory,
  Do as markdownToBlocks,
  Ae as markdownToHTML,
  X as mergeCSSClasses,
  Jr as mergeParagraphs,
  b as nodeToBlock,
  U as nodeToCustomInlineContent,
  Yr as optionalFileZodPropSchema,
  qr as parseAudioElement,
  Zr as parseDefaultProps,
  Q as partialBlockToBlock,
  Qr as partialBlocksToBlocks,
  be as partialInlineContentToInlineContent,
  Xr as partialTableContentToTableContent,
  Qe as propsToAttributes,
  We as prosemirrorSliceToSlicedBlocks,
  le as removeAndInsertBlocks,
  oo as removeEmptyColumns,
  De as selectedFragmentToHTML,
  ea as stylePropsToAttributes,
  ze as tableContentToNodes,
  ta as tableZodPropSchema,
  oa as trackPosition,
  et as updateBlock,
  Ye as updateBlockCommand,
  ot as updateBlockTr,
  ua as uploadToTmpFilesDotOrg_DEV_ONLY,
  na as videoParse,
  pa as withPageBreak,
  sa as wrapInBlockStructure
};
//# sourceMappingURL=blocknote.js.map
